/* eslint-disable @typescript-eslint/no-unused-vars */
import AvatarPlaceHolder from "../../assets/avatar-placeholder.jpg";

const getMockProfile = async () => {
  const mockData = {
    "id": "dd71620e-e2c8-4354-9690-acbc00fdaae5",
    "physicalStreet": "PO Box 35143 #1019",
    "physicalZipCode": "98124",
    "physicalStateName": "Washington",
    "physicalCityName": "Seattle",
    "mailingStreet": "PO Box 35143 #1019",
    "mailingZipCode": "98124",
    "mailingStateName": "Washington",
    "mailingCityName": "Seattle",
    "email": "jeff.jou@builders-capital.com",
    "firstName": "Jeff",
    "lastName": "Jou",
    "subdomain": "testing",
    "mobilePhone": "2065551234",
    "avatarAssetId": "9B734000-7984-E390-3754-853121C21ECC",
    "organizationContactId": "f1231aa6-3415-4afc-a274-a9f900d30695",
    "preferredLoanOfficerOrganizationContactId": "13082e46-5685-4e77-9bfa-a6e100552120",
    "organization": {
      "name": "Builders Capital[3]",
      "id": "dcad7968-e9d9-43e5-a4e7-0037a8244c52",
      "entitySubTypeId": "2612f736-32dc-4550-9396-a64401374f4d",
      "mailingCityName": "Seattle",
      "mailingStateName": "Washington",
      "mailingStreet": "PO Box 35143 #1019",
      "mailingZipCode": "98124",
      "physicalCityName": "Seattle",
      "physicalCounty": "King",
      "physicalState": "Washington",
      "physicalStreet": "PO Box 35143 #1019",
      "physicalZipCode": "98124",
      "themeColor": "#800020",
      "logoAssetId": "fd501c6c-4be3-41a5-82fe-99121ff6bca1"
    },
    "isW9Completed": true,
    "permissions": [
      {
        name: "StandardPortal",
        create: false,
        update: false,
        read: true,
        delete: false,
      },
      {
        name: "BrokerPortal",
        create: false,
        update: false,
        read: true,
        delete: false,
      },
      {
        name: "BorrowerPortal",
        create: false,
        update: false,
        read: true,
        delete: false,
      },
      {
        name: "LoanOfficerPortal",
        create: false,
        update: false,
        read: true,
        delete: false,
      },
      {
        name: "LMSVersion2",
        create: true,
        update: true,
        read: true,
        delete: true,
      },
      {
        name: "GlobalAdminAccess",
        create: true,
        update: true,
        read: true,
        delete: true,
      },
      {
        name: "GlobalProfileAccess",
        create: false,
        update: true,
        read: true,
        delete: false,
      },
      {
        name: "BrokerW9",
        create: false,
        update: false,
        read: true,
        delete: false,
      },
      {
        name: "BrokerDashboard",
        create: false,
        update: false,
        read: true,
        delete: false,
      },
      {
        name: "BrokerSidebar",
        create: false,
        update: false,
        read: true,
        delete: false,
      },
      {
        name: "BrokerGMR",
        create: true,
        update: true,
        read: true,
        delete: true,
      },
      {
        name: "BrokerGMRPricingInfo",
        create: false,
        update: false,
        read: true,
        delete: false,
        export: true,
      },
      {
        name: "StandardGMRCalcDisplay",
        create: false,
        update: false,
        read: true,
        delete: false,
      },
      {
        name: "BrokerBorrowerApplication",
        create: true,
        update: true,
        read: true,
        delete: false,
      },
      {
        name: "BorrowerWhiteLabeledApplication",
        create: false,
        update: false,
        read: false,
        delete: false,
      },
      {
        name: "BorrowerSidebar",
        create: false,
        update: false,
        read: true,
        delete: false,
      },
      {
        name: "GuarantorWhiteLabeledApplication",
        create: false,
        update: false,
        read: false,
        delete: false,
      },
      {
        name: "ChangeInteriorCard",
        create: true,
        update: true,
        read: true,
        delete: true,
      }
    ],
    "brokerages": [
      {
        subdomain: "abc",
        name: "abc brokerage"
      },
      {
        subdomain: "xyz",
        name: "xyz brokerage"
      }
    ]
  };

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockUser = async () => {
  const mockData = [
    {
      "channels": [
        {
          "name": "Wholesale Channel",
          "regionId": "2d35edc1-5d0b-46e8-a932-acc300e082b1",
          "sortOrder": 0
        }
      ],
      "email": "mockuser@gmail.com",
      "id": "39d6304e-d45f-49fc-9d63-41c49fcc2f32",
      "isExternalUser": true,
      "mobilePhone": "1234567890",
      "name": "Mock User",
      "organizationContactId": "389ba857-616a-45e6-9947-a67500cea892",
      "portal": "Broker"
    }
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const deleteMockProfileAvatar = async (assetId) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const deleteMockBrokerLogo = async (assetId) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const createMockProfile = async (profile) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => profile
  });
};

const updateMockProfile = async (profile) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => profile
  });
};

const getMockProfileAsset = async (id) => {
  return await fetch(AvatarPlaceHolder);
};

const updateMockProfileAvatar = async (file, assetId) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const updateMockBrokerLogo = async (file, assetId) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const getMockDashboard = async () => {
  const mockData = {
    "projectTypes": [
      {
        "projectTypeName": "Fix and Flip",
        "projectTypeTotal": 4000000
      },
      {
        "projectTypeName": "Construction",
        "projectTypeTotal": 100005
      },
      {
        "projectTypeName": "Bridge",
        "projectTypeTotal": 50000
      }
    ],
    "topBorrowers": [
      {
        "borrowerName": "James Yurina",
        "amountInCommitment": 10000000
      },
      {
        "borrowerName": "16614 Sylvester Construction",
        "amountInCommitment": 9500000
      },
      {
        "borrowerName": "Preston Hiefield",
        "amountInCommitment": 8250000
      },
      {
        "borrowerName": "Amber Taylor",
        "amountInCommitment": 7900000
      },
      {
        "borrowerName": "Todd Bennett",
        "amountInCommitment": 7850000
      }
    ],
    "dealStatus": {
      "application": 4500000,
      "processing": 500000,
      "closing": 12500000,
      "funded": 8500000,
      "servicing": 6500000
    },
    "closingMonths": [
      {
        "monthNumber": 12,
        "monthName": "Dec",
        "closingAmount": 34619016.65
      },
      {
        "monthNumber": 8,
        "monthName": "Aug",
        "closingAmount": 15689514.87
      },
      {
        "monthNumber": 9,
        "monthName": "Sep",
        "closingAmount": 35274994.96
      },
      {
        "monthNumber": 10,
        "monthName": "Oct",
        "closingAmount": 19086455.59
      },
      {
        "monthNumber": 11,
        "monthName": "Nov",
        "closingAmount": 14484345.91
      },
      {
        "monthNumber": 7,
        "monthName": "Jul",
        "closingAmount": 195000.00
      },
      {
        "monthNumber": 1,
        "monthName": "Jan",
        "closingAmount": 3622259.95
      }
    ]
  };

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockGMRInfolist = async () => {
  const mockData = [
    {
      "id": "b572ee74-da8a-4c59-b0b7-1218fd0c60ce",
      "name": "EE63984F8FC2",
      "loanProgram": "New Construction",
      "numberOfUnitsProperties": 8,
      "submittedOn": null,
      "brokerage": null,
      "brokerEmail": null,
      "gmrNumber": "006607",
      "gmrStatus": null,
      "statusLookupName": "New",
      "statusLookupSortOrder": 0,
      "timeStamp": null,
      "age": null,
      "overTurntime": null,
      "assignedTo": "5d81179c-5086-41fb-806d-acc300e17d01",
      "channels": [
        "2d35edc1-5d0b-46e8-a932-acc300e082b2",
        "cd129023-3da1-43e6-9ac4-e3fa823cbf69"
      ],
      "statusLookupId": "8f20a3d6-84ce-4a38-a267-58fec569aa1d",
      "sortOrder": null,
      "masterGmrId": null,
      "loanCommitment": 2100000.00
    }
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockApplicationInfolist = async () => {
  const mockData = [
    {
      "id": "29f1554d-5744-4dda-92bc-abd058d862b5",
      "name": "7B3877383DF7",
      "loanProgram": "All In One",
      "loanProgramId": "10dadf83-86e1-4f82-b86a-454824397dce",
      "numberOfProposedLots": null,
      "numberOfPropertiesOrUnits": null,
      "developmentOrVerticalPermitTimingInMonths": null,
      "purchaseRefinanceOptionLookupId": null,
      "submittedOn": null,
      "status": null,
      "brokerageOrgId": null,
      "brokerage": null,
      "brokerageSubdomain": null,
      "brokerEmail": null,
      "budget": null,
      "closingDate": null,
      "statusLookupName": "New",
      "statusLookupSortOrder": 0,
      "timeStamp": null,
      "age": null,
      "overTurntime": null,
      "assignedTo": null,
      "channels": [],
      "statusLookupId": null,
      "loanCommitment": 100
    },
    {
      "id": "85ec00ff-5ea6-4a69-b254-7ed898bad3a5",
      "name": "B9C5B3D5BC41",
      "loanProgram": "Bridge",
      "loanProgramId": "a8804f37-5154-42dd-86ff-a8a800eca6d0",
      "numberOfProposedLots": null,
      "numberOfPropertiesOrUnits": 1,
      "developmentOrVerticalPermitTimingInMonths": null,
      "purchaseRefinanceOptionLookupId": null,
      "submittedOn": null,
      "status": null,
      "brokerageOrgId": null,
      "brokerage": null,
      "brokerageSubdomain": null,
      "brokerEmail": null,
      "budget": 0.0,
      "closingDate": "2021-01-17T00:00:00",
      "statusLookupName": "New",
      "statusLookupSortOrder": 0,
      "timeStamp": null,
      "age": null,
      "overTurntime": null,
      "assignedTo": null,
      "channels": [],
      "statusLookupId": null,
      "loanCommitment": 200
    }
  ];
  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockLoanInfolist = async () => {
  const mockData = [
    {
      "id": "9b2087ee-d167-4449-a0bc-ae99000a254c",
      "name": "Test AIO ",
      "loanProgram": "All In One",
      "numberOfUnits": 12,
      "submittedDate": "2022-05-18T00:42:30.413",
      "brokerage": null,
      "brokerEmail": null,
      "statusLookupName": "Processing",
      "closingDate": "2022-05-18T00:42:30.413",
      "loanCommitment": 100
    },
    {
      "id": "0e5c686a-2877-4c7c-989e-cc01bc6f57d4",
      "name": "53657D03C064",
      "loanProgram": "New Construction",
      "numberOfUnits": 4,
      "submittedDate": "2021-09-13T13:00:59.807",
      "brokerage": null,
      "brokerEmail": null,
      "statusLookupName": "Conditionally Approved",
      "closingDate": "2021-09-13T13:00:59.807",
      "loanCommitment": 200
    }
  ];
  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockGMRSummary = async (id) => {
  const mockData = {
    "display": null,
    "borrower": null,
    "entitySubTypeId": null,
    "firstName": null,
    "lastName": null,
    "preferredContactMethodOption": null,
    "email": null,
    "phone": null,
    "redirectWebpage": null,
    "preAssignedLoanOfficer": false,
    "missingRsm": false,
    "missingNsm": false,
    "loanOfficerNullOptionSelected": null,
    "loanOfficerOrganizationContactId": null,
    "projectExperience": null,
    "creditScore": null,
    "loanProgramId": "fd4c0567-8745-411e-b992-40cae5c9bd60",
    "propertyTypeId": "0bf8dfcc-3bb8-445f-97ae-b4af3b26ebdf",
    "name": "Robs Condos",
    "projectZipCode": "98372",
    "purchaseOrRefinanceOption": "Purchase",
    "refinancePayoff": 1000000.00,
    "asIsValue": 1300000.00,
    "budget": 2000000.00,
    "afterRepairValue": 5000000.00,
    "numberOfPropertiesOrUnits": 4,
    "numberOfPlans": null,
    "totalBuildTimeInMonths": 6,
    "estimatedUnitSalesPerMonth": null,
    "monthOfUnitSale": null,
    "monthOfFirstDraw": null,
    "requestedLoanTermInMonths": 12,
    "useInterestReserve": true,
    "cashDown": 2333.22,
    "financeOtherFees": false,
    "otherFee1Name": null,
    "otherFee1Amount": null,
    "otherFee2Name": null,
    "otherFee2Amount": null,
    "haveYouPutAnyMoneyIntoTheProject": null,
    "totalCostsPaidToDate": 33333.11,
    "borrowerProjectExperience": null,
    "estimatedCreditScoreId": null,
    "showSummaryPage": false,
    "submittedOn": null,
    "loanCommitment": 2550000.1,
    "interestRate": 0.1199,
    "originationFeeRate": 0.06,
    "originationFee": 3.15,
    "requiredCashDown": 679948.20,
    "estimatedFeesAndInterest": null,
    "estimatedTitleAndEscrowFee": 2000.00,
    "estimatedAppraisalFee": null,
    "ltv": 0.51,
    "ltc": 0.85,
    "borrowerOrganizationId": null,
    "organizationContactId": null,
    "brokerOrganizationContactId": null,
    "brokerFeeRate": 0.05,
    "brokerFee": 10.33,
    "isActive": null,
    "thresholdMessage": null,
    "document": null,
    "documentFileName": null,
    "portalAccountEmail": null,
    "description": null,
    "createdOn": "0001-01-01T00:00:00",
    "createdBy": null,
    "updatedOn": "0001-01-01T00:00:00",
    "updatedBy": null,
    "lockVersion": 0,
    "wipatClosing": null,
    "interestCalculationMethodId": null,
    "numberOfExtensions": null,
    "extensionRateChangePercentage": null,
    "extensionDays": null,
    "extensionFeePercentage": null,
    "processingFee": null,
    "appraisalFee": null,
    "floodFee": null,
    "creditReportFee": null,
    "propertyBudgetSetupFee": null,
    "legalFee": null,
    "drawAdministrationFee": null,
    "subordinatedDebtAmount": 100.15,
    "realEstateCostsFeePercentage": 0.5,
    "partialDeedReleaseAmount": null,
    "interestPaidByBorrower": 33.22,
    "borrowerOrganization": null,
    "brokerOrganizationContact": null,
    "entitySubType": null,
    "estimatedCreditScore": null,
    "interestCalculationMethod": null,
    "loanOfficerOrganizationContact": null,
    "loanProgram": null,
    "organizationContact": null,
    "propertyType": null,
    "deals": [],
    "scenarios": [],
    "gmrCostPaids": [
      {
        "gmrid": "50f37bf3-a98d-47b9-96e5-862d9a8f0f8b",
        "display": "NA",
        "gmrprojectCostId": "5e275c46-96e0-403d-be44-2b1e3b7c4de5",
        "amount": 250000.0000,
        "description": "Permits and Engineering",
        "createdOn": "2020-08-10T17:05:18.377",
        "createdBy": "gmr@builders-capital.com",
        "updatedOn": "2020-08-10T17:05:18.377",
        "updatedBy": "gmr@builders-capital.com",
        "lockVersion": 0,
        "gmr": null,
        "gmrprojectCost": null,
        "id": "f14c50da-f450-4d89-986a-66e35084f6fb",
        "stringId": "f14c50da-f450-4d89-986a-66e35084f6fb"
      }
    ],
    "gmrEstimatedFees": [],
    "gmrFeeToFinances": [],
    "gmrUnitDrawMonths": [
      {
        "gmrid": "50f37bf3-a98d-47b9-96e5-862d9a8f0f8b",
        "display": "NA",
        "unitNo": 1,
        "monthOfFirstDraw": 1,
        "createdOn": "2020-08-10T17:05:18.377",
        "createdBy": "gmr@builders-capital.com",
        "updatedOn": "2020-08-10T17:05:18.377",
        "updatedBy": "gmr@builders-capital.com",
        "lockVersion": 0,
        "gmr": null,
        "id": "da5bdc33-7a7d-41c1-b1f9-705a1d425a3a",
        "stringId": "da5bdc33-7a7d-41c1-b1f9-705a1d425a3a"
      },
      {
        "gmrid": "50f37bf3-a98d-47b9-96e5-862d9a8f0f8b",
        "display": "NA",
        "unitNo": 4,
        "monthOfFirstDraw": 2,
        "createdOn": "2020-08-10T17:05:18.377",
        "createdBy": "gmr@builders-capital.com",
        "updatedOn": "2020-08-10T17:05:18.377",
        "updatedBy": "gmr@builders-capital.com",
        "lockVersion": 0,
        "gmr": null,
        "id": "cdea57a5-c0f2-4264-9ddb-96623c424e25",
        "stringId": "cdea57a5-c0f2-4264-9ddb-96623c424e25"
      },
      {
        "gmrid": "50f37bf3-a98d-47b9-96e5-862d9a8f0f8b",
        "display": "NA",
        "unitNo": 2,
        "monthOfFirstDraw": 1,
        "createdOn": "2020-08-10T17:05:18.377",
        "createdBy": "gmr@builders-capital.com",
        "updatedOn": "2020-08-10T17:05:18.377",
        "updatedBy": "gmr@builders-capital.com",
        "lockVersion": 0,
        "gmr": null,
        "id": "6e6d222c-fb02-437b-9bbe-c0c8468ef52f",
        "stringId": "6e6d222c-fb02-437b-9bbe-c0c8468ef52f"
      },
      {
        "gmrid": "50f37bf3-a98d-47b9-96e5-862d9a8f0f8b",
        "display": "NA",
        "unitNo": 3,
        "monthOfFirstDraw": 2,
        "createdOn": "2020-08-10T17:05:18.377",
        "createdBy": "gmr@builders-capital.com",
        "updatedOn": "2020-08-10T17:05:18.377",
        "updatedBy": "gmr@builders-capital.com",
        "lockVersion": 0,
        "gmr": null,
        "id": "51f71e4f-55e3-4d71-9a4c-e5e299bed5e2",
        "stringId": "51f71e4f-55e3-4d71-9a4c-e5e299bed5e2"
      }
    ],
    "id": "50f37bf3-a98d-47b9-96e5-862d9a8f0f8b",
    "stringId": "50f37bf3-a98d-47b9-96e5-862d9a8f0f8b",
    "estimatedClosingDate": "2020-08-10T17:05:18.377",
    "interestReserveCurrent": 5.14,
    "collateralValue": 24.11,
    "masterGmrId": "50f37bf3-a98d-47b9-96e5-862d9a8f0f8b",
    "gmrScenarios": [
      {
        "scenarioGmrId": "50f37bf3-a98d-47b9-96e5-862d9a8f0f8b",
        "name": "Robs Condos"
      },
      {
        "scenarioGmrId": "55aff319-0baa-421e-8130-8c1b4f0ab4be",
        "name": "Scenario 1"
      }
    ],
    applicationNumber: 2105018,
    gmrNumber: 111111,
    status: {
      stageName: "Processing"
    }
  };

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 200);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockGMRMetadata = async () => {
  const mockData = {
    "loanPrograms": [
      {
        "id": "4f226397-0eff-40d1-92b6-a63c00d06ba5",
        "name": "Development",
        "description": "Horizontal construction.",
        "isActive": true,
        "createdOn": "2016-07-07T16:38:50.163",
        "createdBy": "Chelsea@builders-capital.com",
        "updatedOn": "2021-01-12T13:06:14.493",
        "updatedBy": "catherine.quinn@builders-capital.com",
        "lockVersion": 7
      },
      {
        "id": "a8804f37-5154-42dd-86ff-a8a800eca6d0",
        "name": "Bridge",
        "description": "Acquisition/Refinance of an existing structure without a construction budget.",
        "isActive": true,
        "createdOn": "2018-03-19T14:21:37.343",
        "createdBy": "brooke@builders-capital.com",
        "updatedOn": "2021-01-12T13:06:23.097",
        "updatedBy": "catherine.quinn@builders-capital.com",
        "lockVersion": 6
      },
      {
        "id": "09fcb6e2-c45e-4961-be52-a8a800f05b6a",
        "name": "Fix and Flip",
        "description": "Rehab of an existing structure.",
        "isActive": true,
        "createdOn": "2018-03-19T14:35:06.813",
        "createdBy": "brooke@builders-capital.com",
        "updatedOn": "2021-01-12T13:06:41.977",
        "updatedBy": "catherine.quinn@builders-capital.com",
        "lockVersion": 10
      },
      {
        "id": "fd4c0567-8745-411e-b992-40cae5c9bd60",
        "name": "New Construction",
        "description": "Vertical construction up to 20 units",
        "isActive": true,
        "createdOn": "2020-10-01T04:08:22.083",
        "createdBy": "BA",
        "updatedOn": "2021-01-13T14:29:25.023",
        "updatedBy": "catherine.quinn@builders-capital.com",
        "lockVersion": 6
      },
      {
        "id": "87100a4b-dc4d-472d-93c7-87f92a3c93c4",
        "name": "All in One",
        "description": "Development and Vertical Construction in one loan",
        "isActive": true,
        "createdOn": "2020-10-01T04:08:22.083",
        "createdBy": "BA",
        "updatedOn": "2021-01-13T14:29:25.023",
        "updatedBy": "catherine.quinn@builders-capital.com",
        "lockVersion": 6
      }
    ],
    "propertyTypes": [
      {
        "id": "2ed7546f-c9ee-486d-94dd-ee681219ffee",
        "name": "Townhome",
        "description": null
      },
      {
        "id": "63af6af7-d139-41a5-b890-a63c00cd1087",
        "name": "Apartment, Multifamily",
        "description": null
      },
      {
        "id": "0bf8dfcc-3bb8-445f-97ae-b4af3b26ebdf",
        "name": "Condo",
        "description": null
      },
      {
        "id": "0a738e27-78a3-4d0f-9385-a63c00cd14d7",
        "name": "Other",
        "description": null
      },
      {
        "id": "ac127be4-a59a-40ec-92d8-f1d15ea9559f",
        "name": "Multi-Unit (duplex, triplex, fourplex)",
        "description": null
      },
      {
        "id": "cec284dd-8fba-48d6-a0ee-a63c00cd08ec",
        "name": "No structure, Land",
        "description": null
      },
      {
        "id": "13a2fbfe-e0bd-4f1e-a56f-ad9600f0853a",
        "name": "Land, Undeveloped",
        "description": null
      },
      {
        "id": "e9240848-0fce-4f21-9e2c-a371adaad0bc",
        "name": "Single Family",
        "description": null
      }
    ],
    "costTypes": [
      {
        "id": "9e9bf949-d560-4743-9b49-044e5fbbb006",
        "name": "Other",
        "description": null,
        "isActive": true,
        "createdOn": "2020-07-30T14:20:49.71",
        "createdBy": null,
        "updatedOn": "2020-07-30T14:20:49.71",
        "updatedBy": null,
        "lockVersion": 0
      },
      {
        "id": "5e275c46-96e0-403d-be44-2b1e3b7c4de5",
        "name": "Construction Costs (Not Financed)",
        "description": null,
        "isActive": true,
        "createdOn": "2020-07-30T14:20:46.593",
        "createdBy": null,
        "updatedOn": "2020-07-30T14:20:46.593",
        "updatedBy": null,
        "lockVersion": 0
      },
      {
        "id": "c573f371-d379-47bb-818e-a2d84bb51aa5",
        "name": "Permits",
        "description": null,
        "isActive": true,
        "createdOn": "2020-07-30T14:20:12.65",
        "createdBy": null,
        "updatedOn": "2020-07-30T14:20:12.65",
        "updatedBy": null,
        "lockVersion": 0
      },
      {
        "id": "6fdffcff-5655-4536-a660-ce1a596c5f96",
        "name": "Engineering",
        "description": null,
        "isActive": true,
        "createdOn": "2020-07-30T14:20:04.793",
        "createdBy": null,
        "updatedOn": "2020-07-30T14:20:04.793",
        "updatedBy": null,
        "lockVersion": 0
      },
      {
        "id": "169fab10-c4af-4d99-8976-d0acd5216cde",
        "name": "Plans",
        "description": null,
        "isActive": true,
        "createdOn": "2020-07-30T14:20:07.607",
        "createdBy": null,
        "updatedOn": "2020-07-30T14:20:07.607",
        "updatedBy": null,
        "lockVersion": 0
      },
      {
        "id": "a3e62af1-9434-400e-88bf-d336b6a490a3",
        "name": "Purchase Price (Equity)",
        "description": null,
        "isActive": true,
        "createdOn": "2020-07-30T14:20:22.19",
        "createdBy": null,
        "updatedOn": "2020-07-30T14:20:22.19",
        "updatedBy": null,
        "lockVersion": 0
      },
      {
        "id": "e1c6035a-ecb9-4486-9a5a-d51351f3091a",
        "name": "Development Costs (Not Financed)",
        "description": null,
        "isActive": true,
        "createdOn": "2020-07-30T14:20:33.75",
        "createdBy": null,
        "updatedOn": "2020-07-30T14:20:33.75",
        "updatedBy": null,
        "lockVersion": 0
      }
    ],
    "loanOfficers": [
      {
        "id": "13082e46-5685-4e77-9bfa-a6e100552120",
        "name": "Mark Woodbridge"
      },
      {
        "id": "1e02b32b-43ba-4ca8-b4fd-a67a011c0b6c",
        "name": "Rich D'Agostino"
      }
    ],
    "entitySubTypes": [
      {
        "id": "c2270692-cfa8-4e6f-acf9-2eea68d7058a",
        "name": "Individual",
        "description": null,
        "isActive": true,
        "createdOn": "2016-05-20T10:12:14.23",
        "createdBy": "info@lightspeedsolutions.com",
        "updatedOn": "2016-05-20T10:12:14.23",
        "updatedBy": "info@lightspeedsolutions.com",
        "lockVersion": 0
      },
      {
        "id": "2612f736-32dc-4550-9396-a64401374f4d",
        "name": "Limited Liability Company",
        "description": null,
        "isActive": true,
        "createdOn": "2016-07-15T22:53:26.67",
        "createdBy": "Chelsea@builders-capital.com",
        "updatedOn": "2016-08-10T15:11:24.93",
        "updatedBy": "Chelsea@builders-capital.com",
        "lockVersion": 1
      },
      {
        "id": "5d0d59f1-62bb-4c5d-940f-a65200d1c52c",
        "name": "Limited Partnership",
        "description": null,
        "isActive": true,
        "createdOn": "2016-07-29T16:43:45.013",
        "createdBy": "Chelsea@builders-capital.com",
        "updatedOn": "2016-08-10T15:11:48.177",
        "updatedBy": "Chelsea@builders-capital.com",
        "lockVersion": 1
      },
      {
        "id": "7fe14bf8-7ef1-43cb-bea4-c782a3ed2c06",
        "name": "Married Couple",
        "description": null,
        "isActive": true,
        "createdOn": "2016-05-20T10:12:14.267",
        "createdBy": "info@lightspeedsolutions.com",
        "updatedOn": "2016-08-10T15:11:57.88",
        "updatedBy": "Chelsea@builders-capital.com",
        "lockVersion": 1
      },
      {
        "id": "fb846206-a4ac-4263-8f13-ca100a4ea5fb",
        "name": "Corporation",
        "description": null,
        "isActive": true,
        "createdOn": "2016-05-20T10:12:14.19",
        "createdBy": "info@lightspeedsolutions.com",
        "updatedOn": "2016-05-20T10:12:14.19",
        "updatedBy": "info@lightspeedsolutions.com",
        "lockVersion": 0
      }
    ],
    "purchaseOrRefinanceOption": [
      {
        "id": "cab23187-a60a-4651-9371-dc6997d5613d",
        "name": "Purchase",
      },
      {
        "id": "aeb8a3f6-333e-45d9-8134-75c448fe2d2f",
        "name": "Refinance",
      },
      {
        "id": "19c2f57e-33d5-4e26-ba54-c6e6376efe07",
        "name": "Own free and clear",
      }
    ]
  };

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockAssociatedBorrowers = async () => {
  const mockData = [];
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockAllBorrowers = async () => {
  const mockData = [];
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockAllBrokers = async () => {
  const mockData = [];
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const calculateMockGMR = async (gmr) => {
  const mockData = {
    id: "e1681931-8285-41b2-83cc-528901758012",
    loanCommitment: 2.1,
    interestRate: 0.49,
    originationFeeRate: 0.39,
    requestedLoanTermInMonths: 2,
    requiredCashDown: 6092.97,
    refinancePayoff: 3,
    ltv: 0.83,
    ltc: 0.70,
    budget: 0,
    estimatedFeesAndInterest: 6092.11,
    useInterestReserve: true,
    brokerFeeRate: 0.5,
    afterRepairValue: 1111
  };

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const submitMockGMR = async (id) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const submitMockMVPGMR = async (gmr) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const getMockApplicationConfig = async () => {
  const mockData = [
    {
      Id: "0e614b33-d267-4450-b251-89c7e01e2df8",
      screenId: "3c30a9e3-b0a6-4a54-8fc5-cc908d1c86b3",
      name: "Loan Program - Bridge",
      value: "a8804f37-5154-42dd-86ff-a8a800eca6d0",
      exclude: [
        "4836b768-c521-493f-b586-27715e1d6517",
        "6d76bb82-4375-4a34-90ca-ea845b163bdd",
        "a213e84d-878f-4b99-a0b0-fb13e6fa9cf5",
        "13268e90-0503-4565-bf81-3515aa760c88",
        "5368a637-df6a-4f13-a286-d15f7125ae51"
      ]
    },
    {
      Id: "3f903cb3-dd69-441d-bed5-8b1de7da64b5",
      screenId: "3c30a9e3-b0a6-4a54-8fc5-cc908d1c86b3",
      name: "Loan Program - Fix and Flip",
      value: "09fcb6e2-c45e-4961-be52-a8a800f05b6a",
      exclude: [
        "4836b768-c521-493f-b586-27715e1d6517",
        "eb55fea6-0fed-4e1c-94b9-b7b3d042723f",
        "6ea04df5-5bcc-481a-a26c-ae5c0e337ad8"
      ]
    },
    {
      Id: "77223c9a-a4ed-4410-93d3-6536a07c3cfe",
      screenId: "3c30a9e3-b0a6-4a54-8fc5-cc908d1c86b3",
      name: "Loan Program - New Construction",
      value: "fd4c0567-8745-411e-b992-40cae5c9bd60",
      exclude: [
        "4836b768-c521-493f-b586-27715e1d6517",
        "eb55fea6-0fed-4e1c-94b9-b7b3d042723f"
      ]
    },
    {
      Id: "764533b7-5c68-4d0c-becc-f5337d81ad68",
      screenId: "3c30a9e3-b0a6-4a54-8fc5-cc908d1c86b3",
      name: "Loan Program - Development",
      value: "4f226397-0eff-40d1-92b6-a63c00d06ba5",
      exclude: [
        "eb55fea6-0fed-4e1c-94b9-b7b3d042723f",
        "3f3bdc6a-7e3b-43a1-a46f-ab96da46855f",
        "f4223761-ea58-4b0b-8703-13d4f1789b79",
        "6ea04df5-5bcc-481a-a26c-ae5c0e337ad8",
        "5368a637-df6a-4f13-a286-d15f7125ae51"
      ]
    },
    {
      Id: "2a96ada9-c8e1-4003-ab16-c4b318587a29",
      screenId: "3c30a9e3-b0a6-4a54-8fc5-cc908d1c86b3",
      name: "Loan Program - All in One",
      value: "87100a4b-dc4d-472d-93c7-87f92a3c93c4",
      exclude: [
        "eb55fea6-0fed-4e1c-94b9-b7b3d042723f",
      ]
    }
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockProfileMetadata = async () => {
  const mockData = {
    "loanOfficers": [
      {
        "id": "13082e46-5685-4e77-9bfa-a6e100552120",
        "name": "Mark Woodbridge"
      },
      {
        "id": "1e02b32b-43ba-4ca8-b4fd-a67a011c0b6c",
        "name": "Rich D'Agostino"
      }
    ],
    "entitySubTypes": [
      {
        "reference": "EntitySubType",
        "id": "fb846206-a4ac-4263-8f13-ca100a4ea5fb",
        "name": "Corporation",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "EntitySubType",
        "id": "2612f736-32dc-4550-9396-a64401374f4d",
        "name": "Limited Liability Company",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "EntitySubType",
        "id": "5d0d59f1-62bb-4c5d-940f-a65200d1c52c",
        "name": "Limited Partnership",
        "description": null,
        "sortOrder": 0
      }
    ]
  };
  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockApplicationMetadata = async () => {
  const mockData = {
    "loanPrograms": [
      {
        "id": "4f226397-0eff-40d1-92b6-a63c00d06ba5",
        "name": "Development",
        "description": "Horizontal construction.",
        "isActive": true,
        "createdOn": "2016-07-07T16:38:50.163",
        "createdBy": "Chelsea@builders-capital.com",
        "updatedOn": "2021-01-12T13:06:14.493",
        "updatedBy": "catherine.quinn@builders-capital.com",
        "lockVersion": 7
      },
      {
        "id": "a8804f37-5154-42dd-86ff-a8a800eca6d0",
        "name": "Bridge",
        "description": "Acquisition/Refinance of an existing structure without a construction budget.",
        "isActive": true,
        "createdOn": "2018-03-19T14:21:37.343",
        "createdBy": "brooke@builders-capital.com",
        "updatedOn": "2021-01-12T13:06:23.097",
        "updatedBy": "catherine.quinn@builders-capital.com",
        "lockVersion": 6
      },
      {
        "id": "09fcb6e2-c45e-4961-be52-a8a800f05b6a",
        "name": "Fix and Flip",
        "description": "Rehab of an existing structure.",
        "isActive": true,
        "createdOn": "2018-03-19T14:35:06.813",
        "createdBy": "brooke@builders-capital.com",
        "updatedOn": "2021-01-12T13:06:41.977",
        "updatedBy": "catherine.quinn@builders-capital.com",
        "lockVersion": 10
      },
      {
        "id": "fd4c0567-8745-411e-b992-40cae5c9bd60",
        "name": "New Construction",
        "description": "Vertical construction up to 20 units",
        "isActive": true,
        "createdOn": "2020-10-01T04:08:22.083",
        "createdBy": "BA",
        "updatedOn": "2021-01-13T14:29:25.023",
        "updatedBy": "catherine.quinn@builders-capital.com",
        "lockVersion": 6
      },
      {
        "id": "87100a4b-dc4d-472d-93c7-87f92a3c93c4",
        "name": "All in One",
        "description": "Development and Vertical Construction in one loan",
        "isActive": true,
        "createdOn": "2020-10-01T04:08:22.083",
        "createdBy": "BA",
        "updatedOn": "2021-01-13T14:29:25.023",
        "updatedBy": "catherine.quinn@builders-capital.com",
        "lockVersion": 6
      }
    ],
    "permitStatuses": [
      {
        "id": "3591db95-8374-4e9a-9dc7-a64400fe12f1",
        "name": "Issued"
      },
      {
        "id": "c87fc9d1-8d80-4ccd-82c9-a64400fe2ae9",
        "name": "Final Engineering"
      },
      {
        "id": "bbeb1c5d-0887-4445-8c54-a64400fe1889",
        "name": "EXPIRED"
      },
      {
        "id": "e9970c8b-8697-40f4-96e9-a64400fe04cf",
        "name": "No Application"
      },
      {
        "id": "6a815df1-43bf-4e04-894f-a64400fe2dbe",
        "name": "Other"
      },
      {
        "id": "0107894a-7605-44bd-a7c8-a64400fe226d",
        "name": "Prelim Engineering"
      },
      {
        "id": "25a2e69a-f729-45c2-9fd9-a7e600d041cb",
        "name": "Submitted"
      },
      {
        "id": "958566e4-4834-4646-9a87-a64400fe0c82",
        "name": "Pending"
      },
      {
        "id": "25a76805-2fa4-40ba-92bd-a737005b050d",
        "name": "Not Applicable"
      }
    ],
    "gmrprojectCosts": [
      {
        "id": "c573f371-d379-47bb-818e-a2d84bb51aa5",
        "name": "Permits",
        "description": null,
        "isActive": true,
        "createdOn": "2020-07-30T14:20:12.65",
        "createdBy": null,
        "updatedOn": "2020-07-30T14:20:12.65",
        "updatedBy": null,
        "lockVersion": 0
      },
      {
        "id": "6fdffcff-5655-4536-a660-ce1a596c5f96",
        "name": "Engineering",
        "description": null,
        "isActive": true,
        "createdOn": "2020-07-30T14:20:04.793",
        "createdBy": null,
        "updatedOn": "2020-07-30T14:20:04.793",
        "updatedBy": null,
        "lockVersion": 0
      }
    ],
    "builders": [
      {
        "id": "13082e46-5685-4e77-9bfa-a6e10055212c",
        "name": "Lokal Communities, LLC"
      },
      {
        "id": "1e02b32b-43ba-4ca8-b4fd-a67a011c0b62",
        "name": "Lokal Two Bridges, LLC"
      }
    ],
    "loanOfficers": [
      {
        "id": "13082e46-5685-4e77-9bfa-a6e100552120",
        "name": "Mark Woodbridge"
      },
      {
        "id": "1e02b32b-43ba-4ca8-b4fd-a67a011c0b6c",
        "name": "Rich D'Agostino"
      }
    ],
    "workStages": [
      {
        "id": "f857ce15-5792-4b8a-902f-8dd5f959fe12",
        "name": "< 10% Complete"
      },
      {
        "id": "11772e9f-06e4-4e93-a17e-299b0c147e51",
        "name": "< 50% Complete"
      }
    ],
    "assetTypes": [
      {
        "id": "e94fb533-e439-438c-be15-666929f31f69",
        "name": "Bank"
      },
      {
        "id": "54ac6490-d08b-4e6e-8f05-9db0fbc2d4f9",
        "name": "Money in Escrow"
      }
    ],
    "alStatuses": [
      {
        "reference": "ALStatus",
        "id": "09b6633c-b9e6-426b-8392-ac8600b4bea1",
        "name": "Closed",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "ALStatus",
        "id": "29186081-6ae1-434d-8b8a-ac8600b4b8f5",
        "name": "Open",
        "description": null,
        "sortOrder": 0
      }
    ],
    "liabilityTypes": [
      {
        "id": "1775df46-a6ac-49b4-b843-a0c7ecefabee",
        "name": "Auto Loan"
      },
      {
        "id": "07df6394-1bdd-40c1-985e-656bffb9ca66",
        "name": "Credit Card"
      }
    ],
    "reoTypes": [
      {
        "id": "35144bfd-6aa6-403c-920b-a06f283f4b74",
        "name": "Apt - Apartment"
      },
      {
        "id": "44dfa045-ad33-4d55-8df9-9de1785f5530",
        "name": "C - Condo"
      }
    ],
    "reoStatuses": [
      {
        "id": "35729e31-969a-4c34-ad0a-3a3d38ea624a",
        "name": "O - Owned"
      },
      {
        "id": "a68a260e-72cd-44b5-a835-e2305219fe52",
        "name": "P - Pending"
      }
    ],
    "maritalStatuses": [
      {
        "id": "a97b069e-aa22-49b8-ac00-7d74509a4739",
        "name": "Married"
      },
      {
        "id": "0b79ff69-5ee8-412d-8734-faa0caad3705",
        "name": "Unmarried"
      }
    ],
    "entityTypes": [

    ],
    "interestCalculationMethods": [
      {
        "reference": "InterestReserve",
        "id": "60fc9905-b347-486a-82a5-6948274dcab4",
        "name": "Monthly Payments",
        "description": null,
        "sortOrder": 100
      },
      {
        "reference": "InterestReserve",
        "id": "af0cc887-8d1b-43c5-b02c-a0056ab80b20",
        "name": "Interest Reserve",
        "description": null,
        "sortOrder": 100
      }
    ],
    "payoffStrategies": [
      {
        "id": "a97b069e-aa22-49b8-ac00-7d74509a4739",
        "name": "Refinance to hold for investment property"
      },
      {
        "id": "0b79ff69-5ee8-412d-8734-faa0caad3705",
        "name": "Sell"
      },
      {
        "id": "66b0c1d8-53fa-481b-8879-1b3346a0fdb0",
        "name": "Other"
      }
    ],
    "ownershipInputs": [
      {
        "reference": "Ownership",
        "id": "ae009dca-8331-4ce2-a722-8cc8f1156279",
        "name": "New Purchase",
        "description": null,
        "sortOrder": 100
      },
      {
        "reference": "Ownership",
        "id": "e0531d10-29d0-4619-8e32-8d502f8f5bb2",
        "name": "More than two years",
        "description": null,
        "sortOrder": 100
      },
      {
        "reference": "Ownership",
        "id": "1738becb-a35d-4a7e-a7a2-93cddd85c57b",
        "name": "Less than two years",
        "description": null,
        "sortOrder": 100
      }
    ],
    "yesNoUnknownInputs": [
      {
        "reference": "YesNoUnknown",
        "id": "759b77ab-f92b-4980-ba2c-5f90a4c0cf6a",
        "name": "No",
        "description": null,
        "sortOrder": 200
      },
      {
        "reference": "YesNoUnknown",
        "id": "11aeecd1-13cc-4236-b7f1-865734ac7465",
        "name": "Yes",
        "description": null,
        "sortOrder": 100
      },
      {
        "reference": "YesNoUnknown",
        "id": "b4f41ef2-f8ef-413b-a3f3-a028cccfca77",
        "name": "Unknown",
        "description": null,
        "sortOrder": 300
      }
    ],
    "builderInputs": [
      {
        "id": "4b7fac75-2b86-44c4-9a51-614e3ac0c6b2",
        "name": "I will be acting as General Contractor"
      },
      {
        "id": "c300f4af-faad-4866-b570-6bac952e39a2",
        "name": "I will be hiring a licensed General Contractor"
      }
    ],
    "borrowers": [
      {
        "reference": "Borrower",
        "id": "1025408a-6304-4142-9cb8-0f409a1b38a0",
        "name": "Modern Northwest, Inc.",
        "description": null,
        "sortOrder": 0
      }
    ],
    "guarantors": [
      {
        id: "f1231aa6-3415-4afc-a274-a9f900d30695",
        firstName: "Robert",
        lastName: "Graham",
        email: "RobertGraham@gmail.com",
      }
    ],
    "entitySubTypes": [
      {
        "reference": "EntitySubType",
        "id": "fb846206-a4ac-4263-8f13-ca100a4ea5fb",
        "name": "Corporation",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "EntitySubType",
        "id": "2612f736-32dc-4550-9396-a64401374f4d",
        "name": "Limited Liability Company",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "EntitySubType",
        "id": "5d0d59f1-62bb-4c5d-940f-a65200d1c52c",
        "name": "Limited Partnership",
        "description": null,
        "sortOrder": 0
      }
    ],
     "unitOfMeasurementInputs": [
        {
            "reference": "UnitOfMeasurement",
            "id": "cb8c9320-c2e9-41b3-b845-698e1ef078f9",
            "name": "acre",
            "display": "acre",
            "description": null,
            "sortOrder": 400
        },
        {
            "reference": "UnitOfMeasurement",
            "id": "bf09baeb-8f96-4b35-ab45-a67a64c3b7e9",
            "name": "sqft",
            "display": "sqft",
            "description": null,
            "sortOrder": 400
        }
    ] 
  };

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockBuilders = async () => {
  const mockData = [
    {
      "id": "13082e46-5685-4e77-9bfa-a6e10055212c",
      "name": "Lokal Communities, LLC"
    },
    {
      "id": "1e02b32b-43ba-4ca8-b4fd-a67a011c0b62",
      "name": "Lokal Two Bridges, LLC"
    }
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const createMockBuilder = async (newBuilder) => {
  const mockData = {
    id: "0e614b33-d267-4450-b251-89c7e01e2dfb",
    organizationName: newBuilder.organizationName
  };

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockBorrowerEntities = async (applicationId) => {
  const mockData = [
    {
      id: "1025408a-6304-4142-9cb8-0f409a1b38a0",
      name: "Modern Northwest, Inc.",
      physicalStreet: "444 Main Street",
      physicalZipCode: 98052,
      physicalCityName: "Redmond",
      physicalStateName: "Washington",
      physicalCountyName: "Kiki",
      employerIdentificationNumber: 123,
      website: "http://localhost:1111",
      yearsInIndustry: 1,
      monthlyRevenue: 2,
      monthlyIncome: 3,
      borrowerProjectExperience: 4,
      alschedules: [
        {
          id: "8023e2f5-0698-46c6-b8c9-503ce6318619",
          "alclassName": "Asset",
          "altypeId": "e94fb533-e439-438c-be15-666929f31f69",
          "institution": "BECU",
          "value": 3,
          "monthlyLiability": null,
          "alstatusId": "29186081-6ae1-434d-8b8a-ac8600b4b8f5",
        },
        {
          id: "55ee083a-0269-440e-aabd-482f91203a50",
          "alclassName": "Liability",
          "altypeId": "1775df46-a6ac-49b4-b843-a0c7ecefabee",
          "institution": "Bank of America",
          "value": 3,
          "monthlyLiability": 4,
          "alstatusId": "09b6633c-b9e6-426b-8392-ac8600b4bea1",
        }
      ],
      reoschedules: [
        {
          id: "55d7857f-d71c-439e-a089-e8ac608a56f2",
          "reotypeId": "35144bfd-6aa6-403c-920b-a06f283f4b74",
          "reostatusId": "a68a260e-72cd-44b5-a835-e2305219fe52",
          "mortgageFree": false,
          "street": "123 Fake Street",
          "zipCode": 98103,
          "stateName": "Washington",
          "cityName": "Seattle",
          "marketValue": 5,
          "monthlyTaxInsuranceAndMaintenance": 6,
          "mortgage1AlscheduleName": "BECU",
          "mortgage2AlscheduleName": "BECU",
          "mortgage3AlscheduleName": "BECU",
          "mortgageAmount1": 7,
          "mortgageAmount2": 8,
          "mortgageAmount3": 9,
          "mortgagePayment1": 10,
          "mortgagePayment2": 11,
          "mortgagePayment3": 12,
          "mortgageHolder1": "Holder 1",
          "mortgageHolder2": "Holder 2",
          "mortgageHolder3": "Holder 3",
          "description": "This is a description"
        }
      ]
    }
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockApplicationSummary = async (id) => {
  const mockData = {
    requestedLoanTermInMonths: 12,
    afterRepairValue: 799000,
    asIsValue: 365000,
    brokerFeeRate: 0.5,
    brokerFees: 0,
    budget: 4000000,
    propertyTypeId: "CEC284DD-8FBA-48D6-A0EE-A63C00CD08EC",
    projectExperience: 4,
    creditScore: 600,
    estimatedFeesAndInterest: 0,
    id: "C8E3F012-641A-4E72-84F7-AB650104C392",
    interestRate: 0.085,
    loanCommitment: 2000000,
    ltc: 0.4,
    ltv: 0.2,
    gmrCostPaids: [
      {
        gmrprojectCostId: "c573f371-d379-47bb-818e-a2d84bb51aa5",
        cost: "Permits",
        amount: 3,
        description: "Description 1"
      },
      {
        gmrprojectCostId: "6fdffcff-5655-4536-a660-ce1a596c5f96",
        cost: "Engineering",
        amount: 4,
        description: "Description 2"
      }
    ],
    gmrUnitDrawMonths: [
      {
        unitNo: 1,
        monthOfFirstDraw: 4
      },
      {
        unitNo: 2,
        monthOfFirstDraw: 5
      }
    ],
    originationFeeRate: 0.02,
    loanProgramId: "09fcb6e2-c45e-4961-be52-a8a800f05b6a",
    projectZipCode: "98103",
    refinancePayoff: 0,
    cashDown: 0,
    requiredCashDown: 0,
    totalBuildTimeInMonths: 6,
    useInterestReserve: true,
    name: "324 W Highland Ave",
  };
  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const upsertMockBorrowerEntity = async (newBorrowerEntity) => {
  const mockData = {
    id: "0e614b33-d267-4450-b251-89c7e01e2dfa",
    name: newBorrowerEntity.name
  };

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockLoanSummary = async (id) => {
  const mockData = {
    requestedLoanTermInMonths: 6,
    afterRepairValue: 799000,
    asIsValue: 365000,
    brokerFeeRate: 0.5,
    brokerFees: 0,
    budget: 4000000,
    propertyTypeId: "e9240848-0fce-4f21-9e2c-a371adaad0bc",
    projectExperience: 4,
    creditScore: 600,
    estimatedFeesAndInterest: 0,
    id: "50f37bf3-a98d-47b9-96e5-862d9a8f0f8b",
    interestRate: 0.085,
    loanCommitment: 2000000,
    ltc: 0.4,
    ltv: 0.2,
    gmrCostPaids: [
      {
        gmrprojectCostId: "c573f371-d379-47bb-818e-a2d84bb51aa5",
        cost: "Permits",
        amount: 3,
        description: "Description 1"
      },
      {
        gmrprojectCostId: "6fdffcff-5655-4536-a660-ce1a596c5f96",
        cost: "Engineering",
        amount: 4,
        description: "Description 2"
      }
    ],
    gmrUnitDrawMonths: [
      {
        unitNo: 1,
        monthOfFirstDraw: 4
      },
      {
        unitNo: 2,
        monthOfFirstDraw: 5
      }
    ],
    originationFeeRate: 0.02,
    loanProgramId: "09fcb6e2-c45e-4961-be52-a8a800f05b6a",
    projectZipCode: "98103",
    refinancePayoff: 0,
    cashDown: 0,
    requiredCashDown: 0,
    totalBuildTimeInMonths: 6,
    useInterestReserve: true,
    name: "324 W Highland Ave",
  };
  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const upsertMockGuarantor = async () => {
  const mockData = [
    {
      "id": "f1231aa6-3415-4afc-a274-a9f900d30695",
      "firstName": "Robert",
      "lastName": "Graham",
      "email": "bobby@nwrootsconstruction.comuat",
      "mobilePhone": "0123456789",
      "physicalStreet": "20 Cake Box Lane",
      "physicalZipCode": "98922",
      "physicalCityId": "e224c91a-df8a-4788-8fae-7f6f3770c657",
      "physicalStateId": "32ff61ff-31d2-4ab0-bcfb-2d88e7c9e21e",
      "physicalCountyId": "d5b7cd9d-641c-4d63-aad5-9778d4c22feb",
      "physicalCityName": "Cle Elum",
      "physicalStateName": "Washington",
      "physicalCountyName": "Kittitas",
      "mailingStreet": "20 Cake Box Lane",
      "mailingZipCode": "98922",
      "mailingCityId": "e224c91a-df8a-4788-8fae-7f6f3770c657",
      "mailingStateId": "32ff61ff-31d2-4ab0-bcfb-2d88e7c9e21e",
      "mailingCountyId": "d5b7cd9d-641c-4d63-aad5-9778d4c22feb",
      "mailingCityName": "Cle Elum",
      "mailingStateName": "Washington",
      "mailingCountyName": "Kittitas",
      "homePhone": null,
      "officePhone": "2532125182",
      "officePhoneExtension": null,
      "positionInCompany": "Member",
      "socialSecurityNumber": "111110833",
      "dateOfBirth": "2021-03-22T09:36:31.777825-07:00",
      "creditScore": 715,
      "creditScoreUpdatedOn": "2021-08-06",
      "isCreditScorePulled": true,
      "maritalStatusId": "a97b069e-aa22-49b8-ac00-7d74509a4739",
      "spouseName": "Jennie Graham",
      "selfEmployed": true,
      "employerName": "NW Roots Construction LLC",
      "employerPosition": "Owner",
      "monthlyIncome": 141149.52,
      "monthlyRevenue": 0.00,
      "yearsInIndustry": 20,
      "yearsInBusiness": 0,
      "yearsInJob": 1,
      "uscitizen": true,
      "citizenshipStatus": "yes",
      "pendingLegalAction": false,
      "legalActionDescription": "No",
      "isForeclosureInitiated": false,
      "foreclosureDescription": "No",
      "otherCreditName": "none",
      "borrowerProjectExperience": null,
      "alschedules": [
        {
          "id": "e21e5f54-34ad-47a6-aedc-aa7300fdb2db",
          "borrowerOrganizationId": null,
          "organizationContactId": "f1231aa6-3415-4afc-a274-a9f900d30695",
          "alclassName": "Asset",
          "alclassId": "b6468698-45bf-4935-ac17-a7fa006be228",
          "altypeId": "37a2fd5a-93e2-43a1-8cd1-a7fa006c1640",
          "institution": "USAA - 8597",
          "value": 31230.45,
          "monthlyLiability": null,
          "alstatusId": null,
          "description": null,
          "isActive": null,
          "createdOn": "2021-03-24T09:36:31.777825-07:00",
          "createdBy": null,
          "updatedOn": "2021-03-24T09:36:31.777851-07:00",
          "updatedBy": null
        }
      ],
      "reoschedules": [
        {
          "id": "0ada98eb-cf4a-4f57-86a1-a8150109e791",
          "borrowerOrganizationId": "1025408a-6304-4142-9cb8-0f409a1b38a0",
          "organizationContactId": null,
          "reotypeId": "38589e61-db46-48ef-b99b-a7fa00211e2a",
          "reostatusId": "922046e6-778f-4249-abc2-a80900a1a5d5",
          "mortgageFree": false,
          "street": "1111 NE Test Ave",
          "zipCode": null,
          "cityId": "02f45a81-b99c-4718-966c-35aa6afd370d",
          "stateId": "c7a223cb-0e64-42f9-b799-ad9805741b38",
          "cityName": "Portland",
          "stateName": "Oregon",
          "marketValue": 23113.00,
          "monthlyTaxInsuranceAndMaintenance": null,
          "mortgage1AlscheduleId": null,
          "mortgage2AlscheduleId": null,
          "mortgage3AlscheduleId": null,
          "mortgage1AlscheduleName": null,
          "mortgage2ALScheduleName": null,
          "mortgage3ALScheduleName": null,
          "mortgageAmount1": 267827.00,
          "mortgageAmount2": 0.00,
          "mortgageAmount3": 0.00,
          "mortgagePayment1": 1.00,
          "mortgagePayment2": 0.00,
          "mortgagePayment3": 0.00,
          "mortgageHolder1": "Builders Capital",
          "mortgageHolder2": null,
          "mortgageHolder3": null,
          "description": null,
          "additionalCollateral": true
        }
      ]
    },
    {
      "id": "c7480c33-8426-4a38-9235-2ac9282659de",
      "firstName": "Tony",
      "lastName": "Stark",
      "email": "bobby@nwrootsconstruction.comuat",
      "mobilePhone": "0123456789",
      "physicalStreet": "20 Cake Box Lane",
      "physicalZipCode": "98922",
      "physicalCityId": "e224c91a-df8a-4788-8fae-7f6f3770c657",
      "physicalStateId": "32ff61ff-31d2-4ab0-bcfb-2d88e7c9e21e",
      "physicalCountyId": "d5b7cd9d-641c-4d63-aad5-9778d4c22feb",
      "physicalCityName": "Cle Elum",
      "physicalStateName": "Washington",
      "physicalCountyName": "Kittitas",
      "mailingStreet": "20 Cake Box Lane",
      "mailingZipCode": "98922",
      "mailingCityId": "e224c91a-df8a-4788-8fae-7f6f3770c657",
      "mailingStateId": "32ff61ff-31d2-4ab0-bcfb-2d88e7c9e21e",
      "mailingCountyId": "d5b7cd9d-641c-4d63-aad5-9778d4c22feb",
      "mailingCityName": "Cle Elum",
      "mailingStateName": "Washington",
      "mailingCountyName": "Kittitas",
      "homePhone": null,
      "officePhone": "253-212-5182",
      "officePhoneExtension": null,
      "positionInCompany": "Member",
      "socialSecurityNumber": "111110833",
      "dateOfBirth": "2021-03-24T09:36:31.777825-07:00",
      "creditScore": 715,
      "maritalStatusId": "a97b069e-aa22-49b8-ac00-7d74509a4739",
      "spouseName": "Jennie Graham",
      "selfEmployed": true,
      "employerName": "NW Roots Construction LLC",
      "employerPosition": "Owner",
      "monthlyIncome": 141149.52,
      "monthlyRevenue": 0.00,
      "yearsInIndustry": 20,
      "yearsInBusiness": 0,
      "yearsInJob": 1,
      "uscitizen": true,
      "citizenshipStatus": "yes",
      "pendingLegalAction": false,
      "legalActionDescription": "No",
      "isForeclosureInitiated": false,
      "foreclosureDescription": "No",
      "otherCreditName": "none",
      "borrowerProjectExperience": null,
      "alschedules": [
        {
          "id": "e21e5f54-34ad-47a6-aedc-aa7300fdb2db",
          "borrowerOrganizationId": null,
          "organizationContactId": "f1231aa6-3415-4afc-a274-a9f900d30695",
          "alclassName": "Asset",
          "alclassId": "b6468698-45bf-4935-ac17-a7fa006be228",
          "altypeId": "37a2fd5a-93e2-43a1-8cd1-a7fa006c1640",
          "institution": "USAA - 8597",
          "value": 31230.45,
          "monthlyLiability": null,
          "alstatusId": null,
          "description": null,
          "isActive": null,
          "createdOn": "2021-03-24T09:36:31.777825-07:00",
          "createdBy": null,
          "updatedOn": "2021-03-24T09:36:31.777851-07:00",
          "updatedBy": null
        }
      ],
      "reoschedules": [
        {
          "id": "0ada98eb-cf4a-4f57-86a1-a8150109e791",
          "borrowerOrganizationId": "1025408a-6304-4142-9cb8-0f409a1b38a0",
          "organizationContactId": null,
          "reotypeId": "38589e61-db46-48ef-b99b-a7fa00211e2a",
          "reostatusId": "922046e6-778f-4249-abc2-a80900a1a5d5",
          "mortgageFree": false,
          "street": "1111 NE Test Ave",
          "zipCode": null,
          "cityId": "02f45a81-b99c-4718-966c-35aa6afd370d",
          "stateId": "c7a223cb-0e64-42f9-b799-ad9805741b38",
          "cityName": "Portland",
          "stateName": "Oregon",
          "marketValue": 1010000.00,
          "monthlyTaxInsuranceAndMaintenance": null,
          "mortgage1AlscheduleId": null,
          "mortgage2AlscheduleId": null,
          "mortgage3AlscheduleId": null,
          "mortgage1AlscheduleName": null,
          "mortgage2ALScheduleName": null,
          "mortgage3ALScheduleName": null,
          "mortgageAmount1": 267827.00,
          "mortgageAmount2": 0.00,
          "mortgageAmount3": 0.00,
          "mortgagePayment1": 1.00,
          "mortgagePayment2": 0.00,
          "mortgagePayment3": 0.00,
          "mortgageHolder1": "Builders Capital",
          "mortgageHolder2": null,
          "mortgageHolder3": null,
          "description": null
        }
      ]
    }
  ];

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const deleteMockGuarantor = async (guarantorObj) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const sendMockLoanApplication = async (sendApplicationInfo) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => sendApplicationInfo
  });
};

const exportMockGMRQuote = async (id) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return await fetch(AvatarPlaceHolder);
};

const getMockGmrScenarios = async (id) => {
  const mockData = [{
    "display": null,
    "borrower": null,
    "entitySubTypeId": null,
    "firstName": null,
    "lastName": null,
    "preferredContactMethodOption": null,
    "email": null,
    "phone": null,
    "redirectWebpage": null,
    "preAssignedLoanOfficer": false,
    "missingRsm": false,
    "missingNsm": false,
    "loanOfficerNullOptionSelected": null,
    "loanOfficerOrganizationContactId": null,
    "projectExperience": null,
    "creditScore": null,
    "loanProgramId": "fd4c0567-8745-411e-b992-40cae5c9bd60",
    "propertyTypeId": "0bf8dfcc-3bb8-445f-97ae-b4af3b26ebdf",
    "name": "Robs Condos",
    "projectZipCode": "98372",
    "purchaseOrRefinanceOption": "Purchase",
    "refinancePayoff": 1000000.00,
    "asIsValue": 1300000.00,
    "budget": 2000000.00,
    "afterRepairValue": 5000000.00,
    "numberOfPropertiesOrUnits": 4,
    "numberOfPlans": null,
    "totalBuildTimeInMonths": 6,
    "estimatedUnitSalesPerMonth": null,
    "monthOfUnitSale": null,
    "monthOfFirstDraw": null,
    "requestedLoanTermInMonths": 12,
    "useInterestReserve": true,
    "cashDown": 2333.22,
    "financeOtherFees": false,
    "otherFee1Name": null,
    "otherFee1Amount": null,
    "otherFee2Name": null,
    "otherFee2Amount": null,
    "haveYouPutAnyMoneyIntoTheProject": null,
    "totalCostsPaidToDate": 33333.11,
    "borrowerProjectExperience": null,
    "estimatedCreditScoreId": null,
    "showSummaryPage": false,
    "submittedOn": null,
    "loanCommitment": 2550000.1,
    "interestRate": 0.1199,
    "originationFeeRate": 0.06,
    "originationFee": 3.15,
    "requiredCashDown": 679948.20,
    "estimatedFeesAndInterest": null,
    "estimatedTitleAndEscrowFee": 2000.00,
    "estimatedAppraisalFee": null,
    "ltv": 0.51,
    "ltc": 0.85,
    "borrowerOrganizationId": null,
    "organizationContactId": null,
    "brokerOrganizationContactId": null,
    "brokerFeeRate": 0.05,
    "brokerFee": 10.33,
    "isActive": null,
    "thresholdMessage": null,
    "document": null,
    "documentFileName": null,
    "portalAccountEmail": null,
    "description": null,
    "createdOn": "0001-01-01T00:00:00",
    "createdBy": null,
    "updatedOn": "0001-01-01T00:00:00",
    "updatedBy": null,
    "lockVersion": 0,
    "wipatClosing": null,
    "interestCalculationMethodId": null,
    "numberOfExtensions": null,
    "extensionRateChangePercentage": null,
    "extensionDays": null,
    "extensionFeePercentage": null,
    "processingFee": null,
    "appraisalFee": null,
    "floodFee": null,
    "creditReportFee": null,
    "propertyBudgetSetupFee": null,
    "legalFee": null,
    "drawAdministrationFee": null,
    "subordinatedDebtAmount": 100.15,
    "realEstateCostsFeePercentage": 0.5,
    "partialDeedReleaseAmount": null,
    "interestPaidByBorrower": 33.22,
    "borrowerOrganization": null,
    "brokerOrganizationContact": null,
    "entitySubType": null,
    "estimatedCreditScore": null,
    "interestCalculationMethod": null,
    "loanOfficerOrganizationContact": null,
    "loanProgram": null,
    "organizationContact": null,
    "propertyType": null,
    "deals": [],
    "scenarios": [],
    "gmrCostPaids": [
      {
        "gmrid": "50f37bf3-a98d-47b9-96e5-862d9a8f0f8b",
        "display": "NA",
        "gmrprojectCostId": "5e275c46-96e0-403d-be44-2b1e3b7c4de5",
        "amount": 250000.0000,
        "description": "Permits and Engineering",
        "createdOn": "2020-08-10T17:05:18.377",
        "createdBy": "gmr@builders-capital.com",
        "updatedOn": "2020-08-10T17:05:18.377",
        "updatedBy": "gmr@builders-capital.com",
        "lockVersion": 0,
        "gmr": null,
        "gmrprojectCost": null,
        "id": "f14c50da-f450-4d89-986a-66e35084f6fb",
        "stringId": "f14c50da-f450-4d89-986a-66e35084f6fb"
      }
    ],
    "gmrEstimatedFees": [],
    "gmrFeeToFinances": [],
    "gmrUnitDrawMonths": [
      {
        "gmrid": "50f37bf3-a98d-47b9-96e5-862d9a8f0f8b",
        "display": "NA",
        "unitNo": 1,
        "monthOfFirstDraw": 1,
        "createdOn": "2020-08-10T17:05:18.377",
        "createdBy": "gmr@builders-capital.com",
        "updatedOn": "2020-08-10T17:05:18.377",
        "updatedBy": "gmr@builders-capital.com",
        "lockVersion": 0,
        "gmr": null,
        "id": "da5bdc33-7a7d-41c1-b1f9-705a1d425a3a",
        "stringId": "da5bdc33-7a7d-41c1-b1f9-705a1d425a3a"
      },
      {
        "gmrid": "50f37bf3-a98d-47b9-96e5-862d9a8f0f8b",
        "display": "NA",
        "unitNo": 4,
        "monthOfFirstDraw": 2,
        "createdOn": "2020-08-10T17:05:18.377",
        "createdBy": "gmr@builders-capital.com",
        "updatedOn": "2020-08-10T17:05:18.377",
        "updatedBy": "gmr@builders-capital.com",
        "lockVersion": 0,
        "gmr": null,
        "id": "cdea57a5-c0f2-4264-9ddb-96623c424e25",
        "stringId": "cdea57a5-c0f2-4264-9ddb-96623c424e25"
      },
      {
        "gmrid": "50f37bf3-a98d-47b9-96e5-862d9a8f0f8b",
        "display": "NA",
        "unitNo": 2,
        "monthOfFirstDraw": 1,
        "createdOn": "2020-08-10T17:05:18.377",
        "createdBy": "gmr@builders-capital.com",
        "updatedOn": "2020-08-10T17:05:18.377",
        "updatedBy": "gmr@builders-capital.com",
        "lockVersion": 0,
        "gmr": null,
        "id": "6e6d222c-fb02-437b-9bbe-c0c8468ef52f",
        "stringId": "6e6d222c-fb02-437b-9bbe-c0c8468ef52f"
      },
      {
        "gmrid": "50f37bf3-a98d-47b9-96e5-862d9a8f0f8b",
        "display": "NA",
        "unitNo": 3,
        "monthOfFirstDraw": 2,
        "createdOn": "2020-08-10T17:05:18.377",
        "createdBy": "gmr@builders-capital.com",
        "updatedOn": "2020-08-10T17:05:18.377",
        "updatedBy": "gmr@builders-capital.com",
        "lockVersion": 0,
        "gmr": null,
        "id": "51f71e4f-55e3-4d71-9a4c-e5e299bed5e2",
        "stringId": "51f71e4f-55e3-4d71-9a4c-e5e299bed5e2"
      }
    ],
    "id": "50f37bf3-a98d-47b9-96e5-862d9a8f0f8b",
    "stringId": "50f37bf3-a98d-47b9-96e5-862d9a8f0f8b",
    "estimatedClosingDate": "2020-08-10T17:05:18.377",
    "interestReserveCurrent": 5.14,
    "collateralValue": 24.11,
    "masterGmrId": "50f37bf3-a98d-47b9-96e5-862d9a8f0f8b",
    "gmrScenarios": [
      {
        "scenarioGmrId": "50f37bf3-a98d-47b9-96e5-862d9a8f0f8b",
        "name": "Robs Condos"
      },
      {
        "scenarioGmrId": "55aff319-0baa-421e-8130-8c1b4f0ab4be",
        "name": "Scenario 1"
      }
    ],
    applicationNumber: 2105018,
    gmrNumber: 111111,
    status: {
      stageName: "Processing"
    }
  }];

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 200);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const exportMockGMRQuotes = async (id) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return await fetch(AvatarPlaceHolder);
};

const upsertMockBorrowerApplication = async (applicationObj) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => applicationObj
  });
};

const getMockApplicationInfo = async (id) => {
  const mockData = {
    id: id,
    screenStatus: "{\"maxScreens\":{\"Projects\":\"59ef5fb1-21a7-41d7-b158-fd843f1f6fc6\"},\"screenNo\":\"f0a258ca-4375-4040-807c-afe661dd330d\"}",
    gmrId: "50f37bf3-a98d-47b9-96e5-862d9a8f0f8b",
    name: "324 W Highland Ave",
    loanProgramId: "87100a4b-dc4d-472d-93c7-87f92a3c93c4",
    zip: 98029,
    cityName: "Sammamish",
    stateName: "Washington",
    countyName: "Snohomish",
    brokerFeeRate: 1.4,
    newStructurePropertyTypeId: "e9240848-0fce-4f21-9e2c-a371adaad0bc",
    existingStructurePropertyTypeId: "2ed7546f-c9ee-486d-94dd-ee681219ffee",
    originalPurchasePrice: 1,
    amountOwed: 22,
    subordinatedDebtAmount: 33,
    noOfProposedLots: 2,
    developmentBeginsAfterClosingInMonths: 3,
    timeFrameToDevelopInMonths: 5,
    horizontalDevelopmentBudget: 12,
    sizeOfCurrentProperty: 55,
    districtReimbursementsAvailableBorrowerApplicationInputId: null,
    districtReimbursementsAvailableDescription: null,
    bondingRequirementsBorrowerApplicationInputId: null,
    bondingRequirementsDescription: null,
    seasonalityConcernsBorrowerApplicationInputId: "11aeecd1-13cc-4236-b7f1-865734ac7465",
    seasonailtyConcernsDescription: "seasonailtyConcernsDescription",
    permitStatusId: "f01f9516-6d43-4868-961c-f27dabfc56b5",
    howLongOwnedBorrowerApplicationInputId: "ae009dca-8331-4ce2-a722-8cc8f1156279",
    useInterestReserveBorrowerApplicationInputId: "a97b069e-aa22-49b8-ac00-7d74509a4739",
    cashDown: 14,
    cashOutAmountRequested: 342,
    loanOfficerOrganizationContactId: "13082e46-5685-4e77-9bfa-a6e100552120",
    loanOfficer: {
      loanOfficerOrganizationContactId: "13082e46-5685-4e77-9bfa-a6e100552120",
      name: "Mark Woodbridge",
      email: "mark.woodbridge@builders-capital.com",
      phone: 2061234567
    },
    portfolioManager: {
      portfolioManagerOrganizationContactId: "13082e46-5685-4e77-9bfa-a6e100552120",
      name: "Rob Trent",
      email: "rob.trent@builders-capital.com",
      phone: 2069876543
    },
    payoffStrategyId: "a97b069e-aa22-49b8-ac00-7d74509a4739",
    budget: 1212.33,
    requestedLoanTermInMonths: 2,
    builderOrganizationId: "13082e46-5685-4e77-9bfa-a6e10055212c",
    payoffStrategyDescription: null,
    requestedClosingDate: "10-08-2014",
    projectComment: null,
    borrowerOrganizationId: "1025408a-6304-4142-9cb8-0f409a1b38a0",
    borrowerContactOrganizationContactId: "f1231aa6-3415-4afc-a274-a9f900d30695",
    screenNo: 21,
    maxScreenNo: 26,
    builder:
    {
      builderOrganizationId: "1025408a-6304-4142-9cb8-0f409a1b38a0",
      name: "Test Org",
      entitySubTypeId: null,
      employerIdentificationNumber: "234-12-1213",
      website: "builderOrg.Website",
      street: "4110 204th St SW",
      cityName: "Lynnwood",
      stateName: "WA",
      zip: 98036
    },
    guarantors: [
      {
        id: "f1231aa6-3415-4afc-a274-a9f900d30695",
        email: "a@c",
        firstName: "Test",
        lastName: "User"
      }
    ],
    borrowerApplicationCostPaids: [
      {
        amount: 234324,
        id: "233e2fed-a6d5-4d3f-886e-9f4b92b06c4c",
        gmrprojectCostId: "c573f371-d379-47bb-818e-a2d84bb51aa5",
        description: "afeafe"
      }
    ],
    borrowerApplicationProperties: [
      {
        id: "03698c54-f2f0-4818-993f-dd4eeda48995",
        street: "321 Main Street",
        zip: 98029,
        cityName: "Sammamish",
        stateName: "Washington",
        countyName: "Snohomish",
        parcelNumber: 32,
        lotNumber: 2,
        zoning: 2,
        existingStructurePropertyTypeId: "e9240848-0fce-4f21-9e2c-a371adaad0bc",
        newStructurePropertyTypeId: "ac127be4-a59a-40ec-92d8-f1d15ea9559f",
        workStageId: "f857ce15-5792-4b8a-902f-8dd5f959fe12",
        collateralProperty: false,
        borrowerApplicationPropertyUnits: [
          {
            id: "beed0517-1105-4ee3-848c-55a8b3164f93",
            unitNumber: "1A",
            borrowerApplicationPlanId: "4cad2268-ed50-4c7c-95f9-d952c93db86d",
            buildTimeInMonths: 1,
            timeFrameToSellOrRefinanceInMonths: 2,
            monthOfFirstDraw: 3,
            numberOfBedroom: 1,
            numberOfBathroom: 2,
            numberOfCarGarage: 3,
            squareFootage: 2013,
            asIsValue: 5,
            afterRepairValue: 6
          },
          {
            id: "37c1a0f8-49e2-421b-ba0d-00a9327a97da",
            unitNumber: "2",
            borrowerApplicationPlanId: "4cad2268-ed50-4c7c-95f9-d952c93db86d",
            buildTimeInMonths: 1,
            timeFrameToSellOrRefinanceInMonths: 2,
            monthOfFirstDraw: 3,
            numberOfBedroom: 1,
            numberOfBathroom: 2,
            numberOfCarGarage: 3,
            squareFootage: 2013,
            asIsValue: 5,
            afterRepairValue: 6
          }
        ],
      },
      {
        id: "0677fccc-8678-4fd8-b2b7-779fb52f7b54",
        street: "345 Main Street",
        zip: 98029,
        cityName: "Sammamish",
        stateName: "Washington",
        countyName: "Snohomish",
        parcelNumber: 32,
        lotNumber: 2,
        zoning: 2,
        existingStructurePropertyTypeId: "2ed7546f-c9ee-486d-94dd-ee681219ffee",
        newStructurePropertyTypeId: "e9240848-0fce-4f21-9e2c-a371adaad0bc",
        workStageId: "f857ce15-5792-4b8a-902f-8dd5f959fe12",
        collateralProperty: false,
        borrowerApplicationPropertyUnits: [
          {
            id: "b5075b97-a279-46e2-9ac3-8afe512d1002",
            unitNumber: "1B",
            borrowerApplicationPlanId: "4cad2268-ed50-4c7c-95f9-d952c93db86d",
            buildTimeInMonths: 1,
            timeFrameToSellOrRefinanceInMonths: 2,
            monthOfFirstDraw: 3,
            numberOfBedroom: 1,
            numberOfBathroom: 2,
            numberOfCarGarage: 3,
            squareFootage: 2013,
            asIsValue: 5,
            afterRepairValue: 6
          }
        ],
      },
      {
        id: "be03a32f-a997-4df4-b8af-546313d7a9db",
        street: "777 Main Street - Apt 111",
        zip: 98052,
        cityName: "Redmond",
        stateName: "Washington",
        countyName: "King",
        parcelNumber: 44,
        lotNumber: 1,
        zoning: 3,
        collateralProperty: true,
        asIsValue: 111,
        numberOfUnits: 2,
        borrowerApplicationPropertyUnits: []
      }
    ],
    borrowerApplicationPlans: [
      {
        id: "4cad2268-ed50-4c7c-95f9-d952c93db86d",
        name: "Test Plan",
        numberOfBedroom: 1,
        numberOfBathroom: 2,
        numberOfCarGarage: 3,
        squareFootage: 2013,
        asIsValue: 5,
        afterRepairValue: 6
      }
    ],
    bypassGuarantorDisclose: true,
    applicationNumber: 2105018,
    status: {
      stageName: "Processing"
    }
  } as any;

  if (id === "b43beb03-8035-396b-0d99-7f2dc8b699b8") {
    mockData.name = "Crystal Brooke Subdivision";
    mockData.submittedOn = "5/5/2021";
  }

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockLoanInfo = async (id) => {
  const mockData = {
    id: id,
    gmrId: "50f37bf3-a98d-47b9-96e5-862d9a8f0f8b",
    name: "324 W Highland Ave",
    loanProgramId: "87100a4b-dc4d-472d-93c7-87f92a3c93c4",
    zip: 98029,
    cityName: "Wenatchee",
    stateName: "Washington",
    countyName: "Snohomish",
    brokerFeeRate: 1.4,
    newStructurePropertyTypeId: "e9240848-0fce-4f21-9e2c-a371adaad0bc",
    existingStructurePropertyTypeId: "2ed7546f-c9ee-486d-94dd-ee681219ffee",
    originalPurchasePrice: 1,
    amountOwed: 22,
    subordinatedDebtAmount: 33,
    noOfProposedLots: 2,
    developmentBeginsAfterClosingInMonths: 3,
    timeFrameToDevelopInMonths: 5,
    horizontalDevelopmentBudget: 12,
    sizeOfCurrentProperty: 55,
    districtReimbursementsAvailableBorrowerApplicationInputId: null,
    districtReimbursementsAvailableDescription: null,
    bondingRequirementsBorrowerApplicationInputId: null,
    bondingRequirementsDescription: null,
    seasonalityConcernsBorrowerApplicationInputId: "11aeecd1-13cc-4236-b7f1-865734ac7465",
    seasonailtyConcernsDescription: "seasonailtyConcernsDescription",
    permitStatusId: "f01f9516-6d43-4868-961c-f27dabfc56b5",
    howLongOwnedBorrowerApplicationInputId: "ae009dca-8331-4ce2-a722-8cc8f1156279",
    useInterestReserveBorrowerApplicationInputId: "a97b069e-aa22-49b8-ac00-7d74509a4739",
    cashDown: 14,
    cashOutAmountRequested: 342,
    loanOfficerOrganizationContactId: "13082e46-5685-4e77-9bfa-a6e100552120",
    loanOfficer: {
      loanOfficerOrganizationContactId: "13082e46-5685-4e77-9bfa-a6e100552120",
      name: "Mark Woodbridge",
      email: "mark.woodbridge@builders-capital.com",
      phone: 2061234567
    },
    portfolioManager: {
      portfolioManagerOrganizationContactId: "13082e46-5685-4e77-9bfa-a6e100552120",
      name: "Rob Trent",
      email: "rob.trent@builders-capital.com",
      phone: 2069876543
    },
    payoffStrategyId: "a97b069e-aa22-49b8-ac00-7d74509a4739",
    budget: 1000.33,
    requestedLoanTermInMonths: 2,
    builderOrganizationId: "13082e46-5685-4e77-9bfa-a6e10055212c",
    payoffStrategyDescription: null,
    requestedClosingDate: "10-08-2014",
    projectComment: null,
    borrowerOrganizationId: "1025408a-6304-4142-9cb8-0f409a1b38a0",
    borrowerContactOrganizationContactId: "f1231aa6-3415-4afc-a274-a9f900d30695",
    screenNo: 21,
    maxScreenNo: 26,
    builder:
    {
      builderOrganizationId: "1025408a-6304-4142-9cb8-0f409a1b38a0",
      name: "Test Org",
      entitySubTypeId: null,
      employerIdentificationNumber: "234-12-1213",
      website: "builderOrg.Website",
      street: "4110 204th St SW",
      cityName: "Lynnwood",
      stateName: "WA",
      zip: 98036
    },
    guarantors: [
      {
        id: "f1231aa6-3415-4afc-a274-a9f900d30695",
        email: "a@c",
        firstName: "Test",
        lastName: "User"
      }
    ],
    loanCostPaids: [
      {
        amount: 234324,
        id: "233e2fed-a6d5-4d3f-886e-9f4b92b06c4c",
        gmrprojectCostId: "c573f371-d379-47bb-818e-a2d84bb51aa5",
        description: "afeafe"
      }
    ],
    loanProperties: [
      {
        loanId: "03698c54-f2f0-4818-993f-dd4eeda48995",
        street: "321 Main Street",
        zip: 98029,
        cityName: "Sammamish",
        stateName: "Washington",
        countyName: "Snohomish",
        parcelNumber: 32,
        lotNumber: 2,
        zoning: 2,
        existingStructurePropertyTypeId: "e9240848-0fce-4f21-9e2c-a371adaad0bc",
        newStructurePropertyTypeId: "0bf8dfcc-3bb8-445f-97ae-b4af3b26ebdf",
        workStageId: "f857ce15-5792-4b8a-902f-8dd5f959fe12",
        collateralProperty: false,
        loanPropertyUnitReconveyances: [
          {
            loanPropertyId: "beed0517-1105-4ee3-848c-55a8b3164f93",
            unitNumber: "1A",
            loanPlanId: "4cad2268-ed50-4c7c-95f9-d952c93db86d",
            buildTimeInMonths: 1,
            timeFrameToSellOrRefinanceInMonths: 2,
            monthOfFirstDraw: 3,
            numberOfBedroom: 1,
            numberOfBathroom: 2,
            numberOfCarGarage: 3,
            squareFootage: 2013,
            asIsValue: 5,
            afterRepairValue: 6
          },
          {
            loanPropertyId: "37c1a0f8-49e2-421b-ba0d-00a9327a97da",
            unitNumber: "2",
            borrowerApplicationPlanId: "4cad2268-ed50-4c7c-95f9-d952c93db86d",
            buildTimeInMonths: 1,
            timeFrameToSellOrRefinanceInMonths: 2,
            monthOfFirstDraw: 3,
            numberOfBedroom: 1,
            numberOfBathroom: 2,
            numberOfCarGarage: 3,
            squareFootage: 2013,
            asIsValue: 5,
            afterRepairValue: 6
          }
        ],
      },
      {
        id: "0677fccc-8678-4fd8-b2b7-779fb52f7b54",
        street: "345 Main Street",
        zip: 98029,
        cityName: "Sammamish",
        stateName: "Washington",
        countyName: "Snohomish",
        parcelNumber: 32,
        lotNumber: 2,
        zoning: 2,
        existingStructurePropertyTypeId: "2ed7546f-c9ee-486d-94dd-ee681219ffee",
        newStructurePropertyTypeId: "e9240848-0fce-4f21-9e2c-a371adaad0bc",
        workStageId: "f857ce15-5792-4b8a-902f-8dd5f959fe12",
        collateralProperty: false,
        loanPropertyUnitReconveyances: [
          {
            loanPropertyId: "b5075b97-a279-46e2-9ac3-8afe512d1002",
            unitNumber: "1B",
            loanPlanId: "4cad2268-ed50-4c7c-95f9-d952c93db86d",
            buildTimeInMonths: 1,
            timeFrameToSellOrRefinanceInMonths: 2,
            monthOfFirstDraw: 3,
            numberOfBedroom: 1,
            numberOfBathroom: 2,
            numberOfCarGarage: 3,
            squareFootage: 2013,
            asIsValue: 5,
            afterRepairValue: 6
          }
        ],
      },
      {
        id: "be03a32f-a997-4df4-b8af-546313d7a9db",
        street: "777 Main Street",
        zip: 98052,
        cityName: "Redmond",
        stateName: "Washington",
        countyName: "King",
        parcelNumber: 44,
        lotNumber: 1,
        zoning: 3,
        collateralProperty: true,
        asIsValue: 111,
        numberOfUnits: 2,
        borrowerApplicationPropertyUnits: []
      }
    ],
    loanPlans: [
      {
        id: "4cad2268-ed50-4c7c-95f9-d952c93db86d",
        name: "Test Plan",
        numberOfBedroom: 1,
        numberOfBathroom: 2,
        numberOfCarGarage: 3,
        squareFootage: 2013,
        asIsValue: 5,
        afterRepairValue: 6
      }
    ],
    bypassGuarantorDisclose: true,
    applicationNumber: 2105018,
    status: {
      stageName: "Processing"
    }
  } as any;

  if (id === "b43beb03-8035-396b-0d99-7f2dc8b699b8") {
    mockData.name = "Current Crystal Brooke Subdivision";
    mockData.submittedOn = "5/5/2021";
  }

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockW9Url = async (brokerId) => {
  const mockData = {
    url: "https://demo.docusign.net/Signing/?insession=1&ti=c0f93466999d42cb8a0550cbc64e2a32"
  };

  return Promise.resolve({
    ok: true,
    json: () => mockData.url
  });
};

const downloadMock = async (id) => {
  return await fetch(AvatarPlaceHolder);
};

const sendMockGMRStartEmail = async (emailObj) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const sendMockApplicationStartEmail = async (emailObj) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const getMockBorrowerEntity = async (borrowerApplicationId, borrowerOrganizationId) => {
  const mockData = {
    "id": "1025408a-6304-4142-9cb8-0f409a1b38a0",
    "name": "Modern Northwest, Inc.",
    "entitySubTypeId": "fb846206-a4ac-4263-8f13-ca100a4ea5fb",
    "physicalStreet": "8101 NE Glisan St - Apt 111",
    "physicalZipCode": "97213",
    "physicalCityId": "02f45a81-b99c-4718-966c-35aa6afd370d",
    "physicalStateId": "c7a223cb-0e64-42f9-b799-ad9805741b38",
    "physicalCountyId": "033543e2-c475-4b59-bfbe-c56365b387e7",
    "physicalCityName": "Portland",
    "physicalStateName": "Oregon",
    "physicalCountyName": "Multnomah",
    "mailingStreet": "8101 NE Glisan St",
    "mailingZipCode": "97213",
    "mailingCityId": "02f45a81-b99c-4718-966c-35aa6afd370d",
    "mailingStateId": "c7a223cb-0e64-42f9-b799-ad9805741b38",
    "mailingCountyId": "033543e2-c475-4b59-bfbe-c56365b387e7",
    "mailingCityName": "Portland",
    "mailingStateName": "Oregon",
    "mailingCountyName": "Multnomah",
    "employerIdentificationNumber": "202704865",
    "website": "www.modernnw.com",
    "isActive": true,
    "yearsInIndustry": 4,
    "monthlyRevenue": 0.12,
    "monthlyIncome": 0.12,
    "borrowerProjectExperience": 15,
    "alschedules": [
      {
        "id": "e21e5f54-34ad-47a6-aedc-aa7300fdb2db",
        "borrowerOrganizationId": null,
        "organizationContactId": "f1231aa6-3415-4afc-a274-a9f900d30695",
        "alclassName": "Asset",
        "alclassId": "b6468698-45bf-4935-ac17-a7fa006be228",
        "altypeId": "e94fb533-e439-438c-be15-666929f31f69",
        "institution": "USAA - 8597",
        "value": 31230.45,
        "monthlyLiability": null,
        "alstatusId": "09b6633c-b9e6-426b-8392-ac8600b4bea1",
        "description": null,
        "isActive": null,
        "createdOn": "2021-03-24T09:36:31.777825-07:00",
        "createdBy": null,
        "updatedOn": "2021-03-24T09:36:31.777851-07:00",
        "updatedBy": null
      },
      {
        "id": "5d652fb9-194e-47b1-bd9d-1556d54625d9",
        "borrowerOrganizationId": null,
        "organizationContactId": "f1231aa6-3415-4afc-a274-a9f900d30695",
        "alclassName": "Liability",
        "alclassId": "b6468698-45bf-4935-ac17-a7fa006be228",
        "altypeId": "1775df46-a6ac-49b4-b843-a0c7ecefabee",
        "institution": "USAA - 1111",
        "value": 2222.45,
        "monthlyLiability": 33.14,
        "alstatusId": "09b6633c-b9e6-426b-8392-ac8600b4bea1",
        "description": null,
        "isActive": null,
        "createdOn": "2021-03-24T09:36:31.777825-07:00",
        "createdBy": null,
        "updatedOn": "2021-03-24T09:36:31.777851-07:00",
        "updatedBy": null
      }
    ],
    "reoschedules": [
      {
        "id": "0ada98eb-cf4a-4f57-86a1-a8150109e791",
        "borrowerOrganizationId": "1025408a-6304-4142-9cb8-0f409a1b38a0",
        "organizationContactId": null,
        "reotypeId": "35144bfd-6aa6-403c-920b-a06f283f4b74",
        "reostatusId": "35729e31-969a-4c34-ad0a-3a3d38ea624a",
        "mortgageFree": false,
        "street": "1111 NE Test Ave",
        "zipCode": null,
        "cityId": "02f45a81-b99c-4718-966c-35aa6afd370d",
        "stateId": "c7a223cb-0e64-42f9-b799-ad9805741b38",
        "cityName": "Portland",
        "stateName": "Oregon",
        "marketValue": 1010000.00,
        "monthlyTaxInsuranceAndMaintenance": 332.10,
        "mortgage1AlscheduleId": null,
        "mortgage2AlscheduleId": null,
        "mortgage3AlscheduleId": null,
        "mortgage1AlscheduleName": null,
        "mortgage2ALScheduleName": null,
        "mortgage3ALScheduleName": null,
        "mortgageAmount1": 267827.00,
        "mortgageAmount2": 0.00,
        "mortgageAmount3": 0.00,
        "mortgagePayment1": 1.00,
        "mortgagePayment2": 0.00,
        "mortgagePayment3": 0.00,
        "mortgageHolder1": "Builders Capital",
        "mortgageHolder2": null,
        "mortgageHolder3": null,
        "description": null,
        "additionalCollateral": true
      }
    ]
  };

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 200);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockGuarantor = async (guarnatorObj) => {
  const mockData = {
    "id": "f1231aa6-3415-4afc-a274-a9f900d30695",
    "firstName": "Robert",
    "lastName": "Graham",
    "email": "bobby@nwrootsconstruction.comuat",
    "mobilePhone": "0123456789",
    "physicalStreet": "20 Cake Box Lane - Apt 111",
    "physicalZipCode": "98922",
    "physicalCityId": "e224c91a-df8a-4788-8fae-7f6f3770c657",
    "physicalStateId": "32ff61ff-31d2-4ab0-bcfb-2d88e7c9e21e",
    "physicalCountyId": "d5b7cd9d-641c-4d63-aad5-9778d4c22feb",
    "physicalCityName": "Cle Elum",
    "physicalStateName": "Washington",
    "physicalCountyName": "Kittitas",
    "mailingStreet": "20 Cake Box Lane - Apt 222",
    "mailingZipCode": "98922",
    "mailingCityId": "e224c91a-df8a-4788-8fae-7f6f3770c657",
    "mailingStateId": "32ff61ff-31d2-4ab0-bcfb-2d88e7c9e21e",
    "mailingCountyId": "d5b7cd9d-641c-4d63-aad5-9778d4c22feb",
    "mailingCityName": "Cle Elum",
    "mailingStateName": "Washington",
    "mailingCountyName": "Kittitas",
    "homePhone": null,
    "officePhone": "253-212-5182",
    "officePhoneExtension": null,
    "positionInCompany": "Member",
    "socialSecurityNumber": "111110833",
    "dateOfBirth": "2021-08-25T00:00:00",
    "estimatedCreditScore": 715,
    "creditScore": null,
    "isCreditScorePulled": false,
    "maritalStatusId": "a97b069e-aa22-49b8-ac00-7d74509a4739",
    "spouseName": "Jennie Graham",
    "selfEmployed": true,
    "employerName": "NW Roots Construction LLC",
    "employerPosition": "Owner",
    "monthlyIncome": 141149.52,
    "monthlyRevenue": 0.00,
    "yearsInIndustry": 20,
    "yearsInBusiness": 0,
    "yearsInJob": 1,
    "uscitizen": true,
    "citizenshipStatus": "yes",
    "pendingLegalAction": false,
    "legalActionDescription": "No",
    "isForeclosureInitiated": false,
    "foreclosureDescription": "No",
    "otherCreditName": "none",
    "borrowerProjectExperience": null,
    "isDisclosureCompleted": true,
    "alschedules": [
      {
        "id": "e21e5f54-34ad-47a6-aedc-aa7300fdb2db",
        "borrowerOrganizationId": null,
        "organizationContactId": "f1231aa6-3415-4afc-a274-a9f900d30695",
        "alclassName": "Asset",
        "alclassId": "b6468698-45bf-4935-ac17-a7fa006be228",
        "altypeId": "e94fb533-e439-438c-be15-666929f31f69",
        "institution": "USAA - 8597",
        "value": 31230.45,
        "monthlyLiability": null,
        "alstatusId": null,
        "description": null,
        "isActive": null,
        "createdOn": "2021-03-24T09:36:31.777825-07:00",
        "createdBy": null,
        "updatedOn": "2021-03-24T09:36:31.777851-07:00",
        "updatedBy": null
      },
      {
        "id": "55b0f11a-234c-43eb-b3c6-5fcf299216d2",
        "borrowerOrganizationId": null,
        "organizationContactId": "f1231aa6-3415-4afc-a274-a9f900d30695",
        "alclassName": "Liability",
        "alclassId": "b6468698-45bf-4935-ac17-a7fa006be228",
        "altypeId": "1775df46-a6ac-49b4-b843-a0c7ecefabee",
        "institution": "USAA - 8597",
        "value": 31230.45,
        "monthlyLiability": 111.12,
        "alstatusId": null,
        "description": null,
        "isActive": null,
        "createdOn": "2021-03-24T09:36:31.777825-07:00",
        "createdBy": null,
        "updatedOn": "2021-03-24T09:36:31.777851-07:00",
        "updatedBy": null,
        "pulledByApi": true
      }
    ],
    "reoschedules": [
      {
        "id": "0ada98eb-cf4a-4f57-86a1-a8150109e791",
        "borrowerOrganizationId": "1025408a-6304-4142-9cb8-0f409a1b38a0",
        "organizationContactId": null,
        "reotypeId": "38589e61-db46-48ef-b99b-a7fa00211e2a",
        "reostatusId": "922046e6-778f-4249-abc2-a80900a1a5d5",
        "mortgageFree": false,
        "street": "1111 NE Test Ave",
        "zipCode": null,
        "cityId": "02f45a81-b99c-4718-966c-35aa6afd370d",
        "stateId": "c7a223cb-0e64-42f9-b799-ad9805741b38",
        "cityName": "Portland",
        "stateName": "Oregon",
        "marketValue": 1010000.00,
        "monthlyTaxInsuranceAndMaintenance": null,
        "mortgage1AlscheduleId": null,
        "mortgage2AlscheduleId": null,
        "mortgage3AlscheduleId": null,
        "mortgage1AlscheduleName": "USAA - 8597",
        "mortgage2ALScheduleName": null,
        "mortgage3ALScheduleName": null,
        "mortgageAmount1": 267827.00,
        "mortgageAmount2": 0.00,
        "mortgageAmount3": 0.00,
        "mortgagePayment1": 1.00,
        "mortgagePayment2": 0.00,
        "mortgagePayment3": 0.00,
        "mortgageHolder1": "Builders Capital",
        "mortgageHolder2": null,
        "mortgageHolder3": null,
        "description": null,
        "additionalCollateral": true
      }
    ]
  };

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const createMockSubdomainUrl = async (subdomain) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const getMockDisclosures = async (brokerId) => {
  const mockData = {
    url: "https://demo.docusign.net/Signing/?insession=1&ti=c0f93466999d42cb8a0550cbc64e2a32"
  };

  return Promise.resolve({
    ok: true,
    json: () => mockData.url
  });
};

const getMockApplicationCopy = async (copyObject) => {
  const mockData = {
    id: copyObject.newBorrowerApplicationId,
    name: "324 W Highland Ave",
    loanProgramId: "87100a4b-dc4d-472d-93c7-87f92a3c93c4",
    newStructurePropertyTypeId: null,
    existingStructurePropertyTypeId: null,
    originalPurchasePrice: 1,
    amountOwed: null,
    subordinatedDebtAmount: 33,
    noOfProposedLots: null,
    developmentBeginsAfterClosingInMonths: null,
    timeFrameToDevelopInMonths: null,
    horizontalDevelopmentBudget: null,
    sizeOfCurrentProperty: null,
    districtReimbursementsAvailableBorrowerApplicationInputId: null,
    districtReimbursementsAvailableDescription: null,
    bondingRequirementsBorrowerApplicationInputId: null,
    bondingRequirementsDescription: null,
    seasonalityConcernsBorrowerApplicationInputId: "11aeecd1-13cc-4236-b7f1-865734ac7465",
    seasonailtyConcernsDescription: "seasonailtyConcernsDescription",
    permitStatusId: null,
    howLongOwnedBorrowerApplicationInputId: null,
    useInterestReserveBorrowerApplicationInputId: "a97b069e-aa22-49b8-ac00-7d74509a4739",
    cashDown: 14,
    cashOutAmountRequested: 342,
    loanOfficerOrganizationContactId: null,
    payoffStrategyId: null,
    budget: 12,
    builderOrganizationId: "13082e46-5685-4e77-9bfa-a6e10055212c",
    payoffStrategyDescription: null,
    projectComment: null,
    borrowerOrganizationId: "1025408a-6304-4142-9cb8-0f409a1b38a0",
    screenNo: 25,
    maxScreenNo: 26,
    guarantors: ["f1231aa6-3415-4afc-a274-a9f900d30695"],
    borrowerApplicationCostPaids: [
      {
        amount: 234324,
        id: "233e2fed-a6d5-4d3f-886e-9f4b92b06c4c",
        gmrprojectCostId: "c573f371-d379-47bb-818e-a2d84bb51aa5",
        description: "afeafe"
      }
    ],
    borrowerApplicationProperties: [
      {
        id: "03698c54-f2f0-4818-993f-dd4eeda48995",
        street: "321 Main Street",
        zip: 98029,
        cityName: "Sammamish",
        stateName: "Washington",
        countyName: "Snohomish",
        parcelNumber: 32,
        lotNumber: 2,
        zoning: 2,
        existingStructurePropertyTypeId: "0bf8dfcc-3bb8-445f-97ae-b4af3b26ebdf",
        newStructurePropertyTypeId: "0bf8dfcc-3bb8-445f-97ae-b4af3b26ebdf",
        workStageId: "f857ce15-5792-4b8a-902f-8dd5f959fe12",
        collateralProperty: false,
        borrowerApplicationPropertyUnits: [
          {
            id: "37c1a0f8-49e2-421b-ba0d-00a9327a97d6",
            borrowerApplicationPlanId: "4cad2268-ed50-4c7c-95f9-d952c93db86d",
            buildTimeInMonths: 1,
            timeFrameToSellOrRefinanceInMonths: 2,
            monthOfFirstDraw: 3,
          },
          {
            id: "37c1a0f8-49e2-421b-ba0d-00a9327a97da",
            borrowerApplicationPlanId: "4cad2268-ed50-4c7c-95f9-d952c93db86d",
            buildTimeInMonths: 1,
            timeFrameToSellOrRefinanceInMonths: 2,
            monthOfFirstDraw: 3,
          }
        ],
      },
      {
        id: "03698c54-f2f0-4818-993f-dd4eeda48996",
        street: "345 Main Street",
        zip: 98029,
        cityName: "Sammamish",
        stateName: "Washington",
        countyName: "Snohomish",
        parcelNumber: 32,
        lotNumber: 2,
        zoning: 2,
        existingStructurePropertyTypeId: "0bf8dfcc-3bb8-445f-97ae-b4af3b26ebdf",
        newStructurePropertyTypeId: "0bf8dfcc-3bb8-445f-97ae-b4af3b26ebdf",
        workStageId: "f857ce15-5792-4b8a-902f-8dd5f959fe12",
        collateralProperty: false,
        borrowerApplicationPropertyUnits: [
          {
            id: "b5075b97-a279-46e2-9ac3-8afe512d1002",
            borrowerApplicationPlanId: "4cad2268-ed50-4c7c-95f9-d952c93db86d",
            buildTimeInMonths: 1,
            timeFrameToSellOrRefinanceInMonths: 2,
            monthOfFirstDraw: 3,
          }
        ],
      },
      {
        id: "be03a32f-a997-4df4-b8af-546313d7a9db",
        street: "777 Main Street",
        zip: 98052,
        cityName: "Redmond",
        stateName: "Washington",
        countyName: "King",
        parcelNumber: 44,
        lotNumber: 1,
        zoning: 3,
        collateralProperty: true,
        asIsValue: 111,
        numberOfUnits: 2,
        borrowerApplicationPropertyUnits: []
      }
    ],
    borrowerApplicationPlans: [
      {
        id: "4cad2268-ed50-4c7c-95f9-d952c93db86d",
        name: "Test Plan",
        numberOfBedroom: 1,
        numberOfBathroom: 2,
        numberOfCarGarage: 3,
        squareFootage: 4,
        asIsValue: 5,
        afterRepairValue: 6
      }
    ],
  };

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const downloadMockLoanDocument = async (documentId) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return await fetch(AvatarPlaceHolder);
};

const getMockLoanDocuments = async (loanId) => {
  const mockData = [
    {
      "id": "adc69cf0-f6d6-41bb-b31c-1fe0738d5431",
      "organizationContactId": "7b4407ec-3a88-6dd3-2ed7-a6650c51dc62",
      "display": "BorrowerApplicationSummary.xlsx",
      "applicationId": "c8e3f012-641a-4e72-84f7-ab650104c392",
      "documentMasterId": "490f646e-4ad8-4a7f-86ee-a6270087cb3c",
      "createdOn": "2021-04-26T13:04:40.197",
      "updatedBy": "Zane Ross",
      "description": "Zane's Description",
      "loanId": loanId,
      "metadata": "1"
    }
  ];

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockLoanDocumentsMetadata = async () => {
  const mockData = {
    "documentAssociationReferences": [
      {
        "reference": "DocumentAssociationReference",
        "id": "04f852a0-57d2-461d-ac00-a6b900666a62",
        "name": "Either",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "DocumentAssociationReference",
        "id": "cc1c2105-fc1c-4f62-8589-a6b900666f42",
        "name": "Loan",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "DocumentAssociationReference",
        "id": "a9ae1620-c03d-411c-b9d6-a6b900667471",
        "name": "Master",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "DocumentAssociationReference",
        "id": "03a13781-3cfd-4187-932b-9693fab3490c",
        "name": "Neither",
        "description": null,
        "sortOrder": 0
      }
    ],
    "documentCategories": [
      {
        "reference": "DocumentCategory",
        "id": "243b3b91-580b-4a48-b885-a75300a24ca7",
        "name": "Accounting",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "DocumentCategory",
        "id": "881254c9-4890-4037-8a16-a6440136cd64",
        "name": "Application",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "DocumentCategory",
        "id": "f648fa56-7021-442c-b185-a62700880627",
        "name": "Borrower",
        "description": null,
        "sortOrder": 0
      }
    ],
    "documentExpiryEnds": [
      {
        "reference": "DocumentExpiryEnd",
        "id": "49709f5d-3915-483e-8391-a6b90066aaa9",
        "name": "Funded",
        "description": "Stop expiry checking after Loan Status = Funded (i.e.: When Loan Phase = Servicing)",
        "sortOrder": 0
      },
      {
        "reference": "DocumentExpiryEnd",
        "id": "f7517b9c-8b46-4c64-8b04-a6b90066b142",
        "name": "N/A",
        "description": "Never check for expiry",
        "sortOrder": 0
      },
      {
        "reference": "DocumentExpiryEnd",
        "id": "13d54513-72e9-49c3-af02-a6b90066b5d9",
        "name": "No",
        "description": "Never stop expiry checking",
        "sortOrder": 0
      },
      {
        "reference": "DocumentExpiryEnd",
        "id": "6f3babdb-cdf6-47d9-b78d-a78a00bc3dd0",
        "name": "Payoff",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "DocumentExpiryEnd",
        "id": "676513c2-d50e-4ca2-a44d-a6b90066bb8d",
        "name": "Signed",
        "description": "Once the signed document is received.  Only applicable to documents being sent manually",
        "sortOrder": 0
      }
    ],
    "documentMaster": [
      {
        "reference": "DocumentMaster",
        "id": "490f646e-4ad8-4a7f-86ee-a6270087cb3c",
        "name": "Balance Sheet",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "DocumentMaster",
        "id": "ad06fff4-1ddd-42ff-909b-a62700887eb4",
        "name": "Drivers License",
        "description": "Expires on Document Date",
        "sortOrder": 0
      },
      {
        "reference": "DocumentMaster",
        "id": "3468ed03-94d4-4e4a-ab24-a6270089daee",
        "name": "Year-end Profit & Loss",
        "description": "Expires next January 31st",
        "sortOrder": 0
      },
      {
        "reference": "DocumentMaster",
        "id": "6ef8b934-8f8c-4285-950e-a627008a324c",
        "name": "Year-to-Date Profit & Loss",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "DocumentMaster",
        "id": "fe2bb38d-458c-4bab-a9dc-a65200c99196",
        "name": "Information Release Authorization",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "DocumentMaster",
        "id": "8fce5660-3eb8-4e03-868e-a65200c9f963",
        "name": "Interest Rate Float Acknowledgement",
        "description": null,
        "sortOrder": 0
      },
      {
        "reference": "DocumentMaster",
        "id": "d12dfc2d-e1ee-4372-9b5b-a65200ca1efe",
        "name": "Inventory Report",
        "description": null,
        "sortOrder": 0
      }
    ]
  };

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const deleteMockLoanDocument = async (documentId) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const updateMockLoanDocument = async (documentObj) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const createMockLoanDocument = async (file, documentObj) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const getMockGuarantors = async (applicationId) => {
  const mockData = [
    {
      "id": "f1231aa6-3415-4afc-a274-a9f900d30695",
      "firstName": "Robert",
      "lastName": "Graham",
      "email": "bobby@nwrootsconstruction.comuat",
      "mobilePhone": "0123456789",
      "physicalStreet": "20 Cake Box Lane",
      "physicalZipCode": "98922",
      "physicalCityId": "e224c91a-df8a-4788-8fae-7f6f3770c657",
      "physicalStateId": "32ff61ff-31d2-4ab0-bcfb-2d88e7c9e21e",
      "physicalCountyId": "d5b7cd9d-641c-4d63-aad5-9778d4c22feb",
      "physicalCityName": "Cle Elum",
      "physicalStateName": "Washington",
      "physicalCountyName": "Kittitas",
      "mailingStreet": "20 Cake Box Lane",
      "mailingZipCode": "98922",
      "mailingCityId": "e224c91a-df8a-4788-8fae-7f6f3770c657",
      "mailingStateId": "32ff61ff-31d2-4ab0-bcfb-2d88e7c9e21e",
      "mailingCountyId": "d5b7cd9d-641c-4d63-aad5-9778d4c22feb",
      "mailingCityName": "Cle Elum",
      "mailingStateName": "Washington",
      "mailingCountyName": "Kittitas",
      "homePhone": null,
      "officePhone": "2532125182",
      "officePhoneExtension": null,
      "positionInCompany": "Member",
      "socialSecurityNumber": "111110833",
      "dateOfBirth": "2021-03-22T09:36:31.777825-07:00",
      "creditScore": 715,
      "creditScoreUpdatedOn": "2021-08-06",
      "isCreditScorePulled": true,
      "maritalStatusId": "a97b069e-aa22-49b8-ac00-7d74509a4739",
      "spouseName": "Jennie Graham",
      "selfEmployed": true,
      "employerName": "NW Roots Construction LLC",
      "employerPosition": "Owner",
      "monthlyIncome": 141149.52,
      "monthlyRevenue": 0.00,
      "yearsInIndustry": 20,
      "yearsInBusiness": 0,
      "yearsInJob": 1,
      "uscitizen": true,
      "citizenshipStatus": "yes",
      "pendingLegalAction": false,
      "legalActionDescription": "No",
      "isForeclosureInitiated": false,
      "foreclosureDescription": "No",
      "otherCreditName": "none",
      "borrowerProjectExperience": null,
      "alschedules": [
        {
          "id": "e21e5f54-34ad-47a6-aedc-aa7300fdb2db",
          "borrowerOrganizationId": null,
          "organizationContactId": "f1231aa6-3415-4afc-a274-a9f900d30695",
          "alclassName": "Asset",
          "alclassId": "b6468698-45bf-4935-ac17-a7fa006be228",
          "altypeId": "37a2fd5a-93e2-43a1-8cd1-a7fa006c1640",
          "institution": "USAA - 8597",
          "value": 31230.45,
          "monthlyLiability": null,
          "alstatusId": null,
          "description": null,
          "isActive": null,
          "createdOn": "2021-03-24T09:36:31.777825-07:00",
          "createdBy": null,
          "updatedOn": "2021-03-24T09:36:31.777851-07:00",
          "updatedBy": null
        }
      ],
      "reoschedules": [
        {
          "id": "0ada98eb-cf4a-4f57-86a1-a8150109e791",
          "borrowerOrganizationId": "1025408a-6304-4142-9cb8-0f409a1b38a0",
          "organizationContactId": null,
          "reotypeId": "38589e61-db46-48ef-b99b-a7fa00211e2a",
          "reostatusId": "922046e6-778f-4249-abc2-a80900a1a5d5",
          "mortgageFree": false,
          "street": "1111 NE Test Ave",
          "zipCode": null,
          "cityId": "02f45a81-b99c-4718-966c-35aa6afd370d",
          "stateId": "c7a223cb-0e64-42f9-b799-ad9805741b38",
          "cityName": "Portland",
          "stateName": "Oregon",
          "marketValue": 23113.00,
          "monthlyTaxInsuranceAndMaintenance": null,
          "mortgage1AlscheduleId": null,
          "mortgage2AlscheduleId": null,
          "mortgage3AlscheduleId": null,
          "mortgage1AlscheduleName": null,
          "mortgage2ALScheduleName": null,
          "mortgage3ALScheduleName": null,
          "mortgageAmount1": 267827.00,
          "mortgageAmount2": 0.00,
          "mortgageAmount3": 0.00,
          "mortgagePayment1": 1.00,
          "mortgagePayment2": 0.00,
          "mortgagePayment3": 0.00,
          "mortgageHolder1": "Builders Capital",
          "mortgageHolder2": null,
          "mortgageHolder3": null,
          "description": null,
          "additionalCollateral": true
        }
      ]
    },
    {
      "id": "c7480c33-8426-4a38-9235-2ac9282659de",
      "firstName": "Tony",
      "lastName": "Stark",
      "email": "bobby@nwrootsconstruction.comuat",
      "mobilePhone": "0123456789",
      "physicalStreet": "20 Cake Box Lane",
      "physicalZipCode": "98922",
      "physicalCityId": "e224c91a-df8a-4788-8fae-7f6f3770c657",
      "physicalStateId": "32ff61ff-31d2-4ab0-bcfb-2d88e7c9e21e",
      "physicalCountyId": "d5b7cd9d-641c-4d63-aad5-9778d4c22feb",
      "physicalCityName": "Cle Elum",
      "physicalStateName": "Washington",
      "physicalCountyName": "Kittitas",
      "mailingStreet": "20 Cake Box Lane",
      "mailingZipCode": "98922",
      "mailingCityId": "e224c91a-df8a-4788-8fae-7f6f3770c657",
      "mailingStateId": "32ff61ff-31d2-4ab0-bcfb-2d88e7c9e21e",
      "mailingCountyId": "d5b7cd9d-641c-4d63-aad5-9778d4c22feb",
      "mailingCityName": "Cle Elum",
      "mailingStateName": "Washington",
      "mailingCountyName": "Kittitas",
      "homePhone": null,
      "officePhone": "253-212-5182",
      "officePhoneExtension": null,
      "positionInCompany": "Member",
      "socialSecurityNumber": "111110833",
      "dateOfBirth": "2021-03-24T09:36:31.777825-07:00",
      "creditScore": 715,
      "maritalStatusId": "a97b069e-aa22-49b8-ac00-7d74509a4739",
      "spouseName": "Jennie Graham",
      "selfEmployed": true,
      "employerName": "NW Roots Construction LLC",
      "employerPosition": "Owner",
      "monthlyIncome": 141149.52,
      "monthlyRevenue": 0.00,
      "yearsInIndustry": 20,
      "yearsInBusiness": 0,
      "yearsInJob": 1,
      "uscitizen": true,
      "citizenshipStatus": "yes",
      "pendingLegalAction": false,
      "legalActionDescription": "No",
      "isForeclosureInitiated": false,
      "foreclosureDescription": "No",
      "otherCreditName": "none",
      "borrowerProjectExperience": null,
      "alschedules": [
        {
          "id": "e21e5f54-34ad-47a6-aedc-aa7300fdb2db",
          "borrowerOrganizationId": null,
          "organizationContactId": "f1231aa6-3415-4afc-a274-a9f900d30695",
          "alclassName": "Asset",
          "alclassId": "b6468698-45bf-4935-ac17-a7fa006be228",
          "altypeId": "37a2fd5a-93e2-43a1-8cd1-a7fa006c1640",
          "institution": "USAA - 8597",
          "value": 31230.45,
          "monthlyLiability": null,
          "alstatusId": null,
          "description": null,
          "isActive": null,
          "createdOn": "2021-03-24T09:36:31.777825-07:00",
          "createdBy": null,
          "updatedOn": "2021-03-24T09:36:31.777851-07:00",
          "updatedBy": null
        }
      ],
      "reoschedules": [
        {
          "id": "0ada98eb-cf4a-4f57-86a1-a8150109e791",
          "borrowerOrganizationId": "1025408a-6304-4142-9cb8-0f409a1b38a0",
          "organizationContactId": null,
          "reotypeId": "38589e61-db46-48ef-b99b-a7fa00211e2a",
          "reostatusId": "922046e6-778f-4249-abc2-a80900a1a5d5",
          "mortgageFree": false,
          "street": "1111 NE Test Ave",
          "zipCode": null,
          "cityId": "02f45a81-b99c-4718-966c-35aa6afd370d",
          "stateId": "c7a223cb-0e64-42f9-b799-ad9805741b38",
          "cityName": "Portland",
          "stateName": "Oregon",
          "marketValue": 1010000.00,
          "monthlyTaxInsuranceAndMaintenance": null,
          "mortgage1AlscheduleId": null,
          "mortgage2AlscheduleId": null,
          "mortgage3AlscheduleId": null,
          "mortgage1AlscheduleName": null,
          "mortgage2ALScheduleName": null,
          "mortgage3ALScheduleName": null,
          "mortgageAmount1": 267827.00,
          "mortgageAmount2": 0.00,
          "mortgageAmount3": 0.00,
          "mortgagePayment1": 1.00,
          "mortgagePayment2": 0.00,
          "mortgagePayment3": 0.00,
          "mortgageHolder1": "Builders Capital",
          "mortgageHolder2": null,
          "mortgageHolder3": null,
          "description": null
        }
      ]
    }
  ];

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const resendMockGuarantorInvite = async (guarantorInviteObj) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const calculateMockGmrFromApplication = async (borrowerApplication) => {
  const mockData = {
    id: "e1681931-8285-41b2-83cc-528901758012",
    loanCommitment: 2.1,
    interestRate: 0.49,
    originationFeeRate: 0.39,
    requestedLoanTermInMonths: 2,
    requiredCashDown: 6092.97,
    refinancePayoff: 3,
    ltv: 0.83,
    ltc: 0.70,
    budget: 0,
    estimatedFeesAndInterest: 6092.11,
    useInterestReserve: true,
    brokerFeeRate: 0.5,
    afterRepairValue: 1111
  };

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const saveMockLoanDetails = async (loanDetails) => {
  const mockData = {
    id: loanDetails.id
  };

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });

  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const addMockBorrowerGuarantors = async (applicationId, invitedGuarantors) => {
  const mockData = invitedGuarantors;
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });

  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const saveMockProperties = async (properties) => {
  const mockData = {
    id: properties.id
  };

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });

  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const deleteMockSubdomain = async (subdomain) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });

  await mockDelay;
  return Promise.resolve({
    ok: true
  });
};

const getMockBrokerGuarantors = async (borrowerOrganizationId, applicationId) => {
  const mockData = [
    {
      "id": "b72bfd81-ab27-4a3e-b996-0b6b5fe08693",
      "firstName": "Jeff",
      "lastName": "Jou",
      "email": "jejou@gmail.com"
    },
    {
      "id": "6d906b66-17e7-4a58-aa59-b09095511f64",
      "firstName": "Verena",
      "lastName": "Girgis",
      "email": "vgirgis@gmail.com"
    }
  ];

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockGuarantorGuarantors = async (borrowerOrganizationId) => {
  const mockData = [
    {
      "id": "b72bfd81-ab27-4a3e-b996-0b6b5fe08693",
      "firstName": "Jeff",
      "lastName": "Jou",
      "email": "jejou@gmail.com"
    },
    {
      "id": "6d906b66-17e7-4a58-aa59-b09095511f64",
      "firstName": "Verena",
      "lastName": "Girgis",
      "email": "vgirgis@gmail.com"
    }
  ];

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockGuarantorExists = async (email) => {
  const mockData = {
    "id": "b72bfd81-ab27-4a3e-b996-0b6b5fe08693",
    "firstName": "Jeff",
    "lastName": "Jou",
    "email": "jejou@gmail.com"
  };

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    status: 204,
    json: () => mockData
  });
};

const pullMockCreditScore = async (creditUser) => {
  const mockData = 767;

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 1000);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const isMockProjectNameExists = async (projectName) => {
  const mockData = {
    id: "d352b607-9f32-4b4c-a794-f727d7876b91",
    name: projectName
  };
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 200);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    status: 204,
    json: () => mockData
  });
};

const declineMockGuarantorInvitation = async (declineId, declineObj) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const acceptMockGuarantorInvitation = async (declineObj) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const getMockGuarantorDeclineReason = async (borrowerApplicationId, email, declineId) => {
  const mockData = {
    id: "d352b607-9f32-4b4c-a794-f727d7876b91"
  };

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockBrokerBuilder = async (builderOrganizationId) => {
  const mockData = {
    id: "d352b607-9f32-4b4c-a794-f727d7876b91"
  };

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const submitMockBorrowerApplication = async (submitObj) => {
  const mockData = {
    id: submitObj.id,
    hasInvoices: true
  };

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    status: 200,
    json: () => mockData
  });
};

const patchMockBorrowerApplicationProjectSection = async (patchObj, isUpsert) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const patchMockBorrowerApplicationProperties = async (patchObj, isUpsert) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const patchMockBorrowerApplicationPlans = async (patchObj, isUpsert) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const patchMockBorrowerApplicationCostsPaids = async (applicationId, patchObj, isUpsert) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const deleteMockBorrowerApplicationCostsPaids = async (alscheduleId) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const deleteMockBorrowerApplicationPlans = async (alscheduleId) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const deleteMockBorrowerApplicationPropertiesAndUnits = async (alscheduleId) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const deleteMockBorrowerApplicationUnits = async (alscheduleId) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const deleteMockGuarantorALSchedule = async (alscheduleId) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const deleteMockLoanProperty = async (propertyId) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const addMockLoanUnits = async (units) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const deleteMockLoanUnit = async (unitId) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const deleteMockLoanCostsPaids = async (alscheduleId) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const updateMockGmrStatus = async (gmrObj) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const sendMockApplicationToPrescreener = async (applicationId) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const requestMockApplicationRevision = async (applicationId, revisionObj) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const submitMockApplicationForReview = async (applicationId) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });

  await mockDelay;
  return Promise.resolve({
    ok: true
  });
};

const getMockPayeezyLoanInvoices = async (loanId) => {
  const mockData = {};

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockPayeezyPaymentPage = async (invoiceId) => {
  const mockData = {};

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const downloadMockPayeezyInvoice = async (invoiceId) => {
  const mockData = {};

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockGmrBrokerMetadata = async () => {
  const mockData =
  {
    brokers: [
      {
        "reference": "Broker",
        "id": "7cf39094-4020-4da1-a319-2c081f15cdcb",
        "firstName": "Johnny",
        "lastName": "Broker",
        "email": "jbroker+100@gmail.com",
        "sortOrder": 0
      },
      {
        "reference": "Broker",
        "id": "3cf17094-9020-4da1-a321-2c081f1cdcb",
        "firstName": "Amber",
        "lastName": "Broker",
        "email": "abroker+200@gmail.com",
        "sortOrder": 0
      },
    ]
  };

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockGmrEmployeesMetadata = async () => {
  const mockData = [
    {
      email: "jeff@gmail.com",
      Name: "jeff",
      role: "senior developer"
    },
    {
      email: "john@gmail.com",
      Name: "john",
      role: "junior developer"
    },
    {
      email: "raju@gmail.com",
      Name: "raju",
      role: "developer developer"
    }
  ];

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockLoanComments = async (loanId) => {
  const mockData = [
    {
      "id": "d79a1134-0228-45ba-ba5d-25ea925587ad",
      "subject": "Accounting",
      "category": "Application",
      "description": "This is an external comment",
      "isExternal": 1,
      "createdBy": "TonyStark@gmail.com",
      "createdOn": "2022-01-19 18:45:38.170",
      "fullName": "Tony Stark",
      "emailToList": [{
        email: "JT3Guarantor@gmail.com",
        title: "Guarantor"
      }]
    }
  ];

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const createMockLoanComment = async (loanCommentObj) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });

  await mockDelay;
  return Promise.resolve({
    ok: true
  });
};

const patchMockLoanComments = async (loanCommentObj) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });

  await mockDelay;
  return Promise.resolve({
    ok: true
  });
};

const getMockInternalContacts = async () => {
  const mockData = [
    {
      name: "Natasha Romanov",
      email: "BlackWidow@gmail.com",
      title: null
    }
  ];

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const createMockDeal = async (dealObj) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });

  await mockDelay;
  return Promise.resolve({
    ok: true
  });
};

const getMockBrokerEmailExists = async (email) => {
  const mockData = {
    "email": "brokerexists@gmail.com"
  };

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    status: 204,
    json: () => mockData
  });
};

const createMockNewBroker = async () => {
  const mockData = {
    "id": "8f990016-a8f6-492e-8f86-2f7cd771b7b1",
    "brokerEmail": "newBrokerTest@gmail.com",
    "firstName": "ztest",
    "lastName": "Last",
    "phone": "5555555555",
    "organizationName": "myGCompany",
    "organizationTypeId": "93318989-BDEE-47A2-862F-A6B000A05D4A",
    "organizationEmail": "newBrokerCompanyTest@gmail.com",
    "physicalStreet": "12312 134th Court Northeast",
    "physicalZipCode": "98052",
    "physicalCityName": "Redmond",
    "physicalStateName": "Washington",
    "physicalCountyName": "King",
    "mailingStreet": "12312 134th Court Northeast",
    "mailingZipCode": "98052",
    "mailingCityName": "Redmond",
    "mailingStateName": "Washington",
    "mailingCountyName": "King"
  };

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockSimilarBrokerageNameList = async () => {
  const mockData = [
    {
      "id": "af023868-3ffa-4a7f-ad00-f39787d0330e",
      "name": "Builders",
      "entitySubTypeId": "fb846206-a4ac-4263-8f13-ca100a4ea5fb",
    },
    {
      "id": "8522a792-efd1-4f71-8062-1a5ba86c989e",
      "name": "Builders Capital",
      "entitySubTypeId": "2612f736-32dc-4550-9396-a64401374f4d",
    },
    {
      "id": "f0443793-6439-40ca-a254-cae7c1646c3b",
      "name": "Builders Company",
      "entitySubTypeId": "5d0d59f1-62bb-4c5d-940f-a65200d1c52c",
    },
    {
      "id": "85e19dfd-ce2d-4cf8-8a03-5f8dd9971b02",
      "name": "Builders Group",
      "entitySubTypeId": "fb846206-a4ac-4263-8f13-ca100a4ea5fb",
    },
    {
      "id": "638410a2-0de2-461a-aa6f-2a5cfdea7312",
      "name": "Build More",
      "entitySubTypeId": "2612f736-32dc-4550-9396-a64401374f4d",
    },
  ];
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 1000);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const sendMockEmailToBroker = async (brokerEmailObj) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;
  return Promise.resolve({
    ok: true
  });
};

const getMockGmrBorrowers = async () => {
  const mockData = [];

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const patchMockBorrowerApplicationEntities = async (patchObj, isUpsert) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const getMockBorrowerApplicationEntities = async (applicationId) => {
  const mockData = [];

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const downloadMockPropertyUnitExcel = async (numberOfProperties) => {
  const mockData = {
    "numberOfProperties": numberOfProperties
  };

  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const importMockPropertyUnitExcel = async () => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true
  });
};

const getMockBorrowerApplicationGuarantorSigned = async (applicationId) => {
  const mockData = true;
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const postMockGuarantorInvitation = async (guarantorInvitationObj) => {
  const mockData = true;
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;
  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const submitMockAnonymousGmr = async (gmr) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });

  await mockDelay;
  return Promise.resolve({
    ok: true
  });
};

const exportMockWorkbookFromGmr = async (gmrId) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return await fetch(AvatarPlaceHolder);
};

const exportMockWorkbookFromApplication = async (gmrId) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });
  await mockDelay;

  return await fetch(AvatarPlaceHolder);
};

const notifyMockLoanOfficer = async (gmr) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });

  await mockDelay;
  return Promise.resolve({
    ok: true
  });
};

const createMockBorrowerApplicationGuarantors = async (guarantors) => {
  const mockDelay = new Promise((resolve) => {
    setTimeout(resolve, 500);
  });

  await mockDelay;
  return Promise.resolve({
    ok: true
  });
};

export {
  getMockProfile,
  getMockUser,
  deleteMockProfileAvatar,
  deleteMockBrokerLogo,
  createMockProfile,
  updateMockProfile,
  getMockProfileAsset,
  updateMockProfileAvatar,
  updateMockBrokerLogo,
  getMockDashboard,
  getMockGMRInfolist,
  getMockLoanInfolist,
  getMockApplicationInfolist,
  getMockGMRSummary,
  getMockGMRMetadata,
  getMockAssociatedBorrowers,
  getMockAllBorrowers,
  getMockAllBrokers,
  calculateMockGMR,
  submitMockGMR,
  submitMockMVPGMR,
  getMockApplicationConfig,
  getMockApplicationMetadata,
  getMockBuilders,
  createMockBuilder,
  getMockApplicationSummary,
  getMockLoanSummary,
  getMockBorrowerEntities,
  upsertMockBorrowerEntity,
  upsertMockGuarantor,
  deleteMockGuarantor,
  sendMockLoanApplication,
  exportMockGMRQuote,
  exportMockGMRQuotes,
  getMockGmrScenarios,
  upsertMockBorrowerApplication,
  getMockApplicationInfo,
  getMockW9Url,
  downloadMock,
  sendMockGMRStartEmail,
  sendMockApplicationStartEmail,
  getMockBorrowerEntity,
  getMockGuarantor,
  createMockSubdomainUrl,
  getMockDisclosures,
  getMockApplicationCopy,
  downloadMockLoanDocument,
  getMockLoanDocuments,
  getMockLoanDocumentsMetadata,
  deleteMockLoanDocument,
  updateMockLoanDocument,
  createMockLoanDocument,
  getMockGuarantors,
  getMockProfileMetadata,
  resendMockGuarantorInvite,
  calculateMockGmrFromApplication,
  saveMockLoanDetails,
  saveMockProperties,
  addMockBorrowerGuarantors,
  deleteMockSubdomain,
  getMockBrokerGuarantors,
  getMockGuarantorGuarantors,
  getMockGuarantorExists,
  getMockLoanInfo,
  pullMockCreditScore,
  isMockProjectNameExists,
  declineMockGuarantorInvitation,
  acceptMockGuarantorInvitation,
  getMockGuarantorDeclineReason,
  getMockBrokerBuilder,
  submitMockBorrowerApplication,
  patchMockBorrowerApplicationProjectSection,
  patchMockBorrowerApplicationProperties,
  patchMockBorrowerApplicationPlans,
  patchMockBorrowerApplicationCostsPaids,
  deleteMockBorrowerApplicationCostsPaids,
  deleteMockBorrowerApplicationPlans,
  deleteMockBorrowerApplicationPropertiesAndUnits,
  deleteMockBorrowerApplicationUnits,
  deleteMockGuarantorALSchedule,
  deleteMockLoanProperty,
  addMockLoanUnits,
  deleteMockLoanUnit,
  deleteMockLoanCostsPaids,
  updateMockGmrStatus,
  sendMockApplicationToPrescreener,
  requestMockApplicationRevision,
  submitMockApplicationForReview,
  getMockPayeezyLoanInvoices,
  getMockPayeezyPaymentPage,
  downloadMockPayeezyInvoice,
  getMockLoanComments,
  createMockLoanComment,
  patchMockLoanComments,
  getMockInternalContacts,
  createMockDeal,
  getMockGmrBrokerMetadata,
  getMockGmrEmployeesMetadata,
  getMockBrokerEmailExists,
  createMockNewBroker,
  getMockSimilarBrokerageNameList,
  sendMockEmailToBroker,
  getMockGmrBorrowers,
  patchMockBorrowerApplicationEntities,
  getMockBorrowerApplicationEntities,
  downloadMockPropertyUnitExcel,
  importMockPropertyUnitExcel,
  getMockBorrowerApplicationGuarantorSigned,
  postMockGuarantorInvitation,
  submitMockAnonymousGmr,
  exportMockWorkbookFromGmr,
  exportMockWorkbookFromApplication,
  notifyMockLoanOfficer,
  createMockBorrowerApplicationGuarantors
};